var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _circle, _path295, _circle2, _path296, _circle3, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvRedLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 220,
    viewBox: "0 0 370 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 33.8421L290.626 32V146.155L287 147.997V33.8421Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.625 32L294.769 35.5V151.065L290.625 146.155V32Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M323.18 52.7432L318 49V161.58L323.18 163.763V52.7432Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.035 55.5509L323.179 52.7441V163.765L319.035 165.948V55.5509Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240 60.7446L243.626 59V172.924L240 168.855V60.7446Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240 60.7441L244.144 65.3941V173.505L240 168.855V60.7441Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.784 158.811C286.005 153.318 278.379 140.408 278.042 128.78C277.946 125.461 278.569 119.41 283.812 116.172C286.945 114.376 291.231 114.579 295.987 117.211C305.783 122.636 313.863 136.321 314.035 147.776C314.124 153.672 312.098 157.828 308.622 159.822C303.801 162.274 299.428 160.688 295.784 158.811Z",
    fill: "#B9CDE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.088 118.889C280.478 118.185 284.714 116.041 291.903 119.91C306.814 127.935 316.476 154.77 303.877 162.549L279.088 118.889Z",
    fill: "#EFF7FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.877 162.548C304.556 162.158 305.166 161.649 305.73 161.076L306.052 160.77C305.903 160.937 305.751 161.099 305.591 161.251C305.07 161.76 304.495 162.194 303.877 162.548Z",
    fill: "url(#paint0_linear_9008_207327)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.568 162.953C278.789 157.462 271.16 144.55 270.823 132.922C270.727 129.603 271.35 123.552 276.596 120.317C279.728 118.518 284.013 118.72 288.768 121.356C298.564 126.78 306.644 140.463 306.816 151.918C306.905 157.814 304.879 161.97 301.403 163.964C296.584 166.416 292.209 164.83 288.568 162.953Z",
    fill: "#B9CDE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.936 132.391L256.006 132.15C257.546 131.385 261.729 129.543 268.641 133.262C283.489 141.254 293.129 167.897 280.77 175.802L280.519 175.739L255.936 132.391Z",
    fill: "#EFF7FD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.609 175.902L280.847 175.737C281.475 175.347 282.053 174.873 282.577 174.321C282.82 174.08 283.04 173.824 283.25 173.561C282.962 173.941 282.65 174.29 282.319 174.612C281.807 175.106 281.25 175.529 280.647 175.879C280.635 175.887 280.622 175.894 280.609 175.902Z",
    fill: "url(#paint1_linear_9008_207327)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.302 176.309C255.528 170.816 247.899 157.906 247.56 146.276C247.463 142.959 248.084 136.909 253.33 133.67C256.46 131.874 260.746 132.077 265.502 134.709C275.298 140.134 283.378 153.819 283.55 165.274C283.639 171.17 281.613 175.326 278.137 177.32C273.318 179.773 268.945 178.184 265.302 176.309Z",
    fill: "#B9CDE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.022 179.256C266.12 179.256 264.388 178.919 262.831 178.418C261.395 177.956 260.109 177.353 258.982 176.75C257.514 175.919 256.111 174.916 254.792 173.773C253.528 172.676 252.343 171.452 251.254 170.13L251.29 170.097C253.513 172.795 256.103 175.121 258.982 176.75C261.319 178.002 264.34 179.208 267.961 179.208C269.419 179.208 270.974 179.013 272.62 178.549C272.673 178.549 272.726 178.552 272.782 178.552C272.764 178.56 272.747 178.565 272.729 178.57C271.063 179.054 269.493 179.256 268.022 179.256ZM245.783 160.608C245.773 160.58 245.762 160.552 245.752 160.527C245.724 160.451 245.699 160.377 245.671 160.301C245.618 160.152 245.565 160.002 245.514 159.853C244.615 157.215 244.084 154.496 243.995 151.833C244.096 154.752 244.777 157.722 245.828 160.6C245.813 160.603 245.798 160.605 245.783 160.608ZM243.982 150.997C243.993 148.681 244.357 145.993 245.512 143.335C246.135 141.906 246.983 140.484 248.127 139.136L248.272 139.053C244.919 142.932 244 147.409 243.982 150.997Z",
    fill: "url(#paint2_linear_9008_207327)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.804 158.044C265.186 158.044 266.64 157.907 268.144 157.608C266.637 157.907 265.189 158.044 263.804 158.044Z",
    fill: "url(#paint3_linear_9008_207327)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M246.236 171.247C244.099 170.064 242.337 167.082 242.301 164.583C242.263 162.085 243.965 161.018 246.102 162.202C248.239 163.385 250.001 166.37 250.037 168.868C250.075 171.366 248.373 172.43 246.236 171.247Z",
    fill: "#ABBCCB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.317 153.754C315.319 153.751 315.319 153.748 315.322 153.746L315.438 153.584C315.909 153.014 316.334 152.433 316.696 151.833L316.795 151.658C317.145 151.058 317.446 150.444 317.702 149.826L317.76 149.71C317.195 151.111 316.405 152.482 315.317 153.754ZM317.76 149.71L317.818 149.56L317.97 149.134L318.094 148.78C318.013 149.033 317.925 149.284 317.828 149.532L317.76 149.71ZM318.094 148.78L318.208 148.422L318.363 147.878L318.433 147.624C318.375 147.855 318.309 148.083 318.241 148.313L318.094 148.78ZM318.433 147.624L318.512 147.272C318.704 146.436 318.831 145.602 318.904 144.781L318.92 144.632C318.988 143.801 319.006 142.985 318.98 142.093C318.953 141.295 318.887 140.532 318.79 139.749C318.694 139.017 318.578 138.328 318.449 137.71C318.461 137.765 318.471 137.821 318.484 137.877V137.882C318.484 137.887 318.487 137.895 318.489 137.902V137.912C318.492 137.917 318.492 137.922 318.494 137.927C318.494 137.933 318.494 137.938 318.497 137.943C318.497 137.948 318.499 137.953 318.499 137.958C318.499 137.963 318.502 137.968 318.502 137.973C318.502 137.976 318.504 137.981 318.504 137.983C318.507 137.991 318.507 137.998 318.509 138.006V138.011C318.996 140.497 319.307 143.922 318.497 147.366L318.433 147.624ZM318.441 137.672C318.038 135.738 317.345 133.681 317.091 132.964C317.643 134.469 318.102 136.042 318.441 137.672ZM317.069 132.903C316.479 131.302 315.777 129.774 315 128.335C314.987 128.314 314.977 128.294 314.967 128.276C314.967 128.274 314.967 128.274 314.965 128.271C314.218 126.895 313.4 125.601 312.531 124.395C314.309 126.865 315.886 129.715 317.051 132.852C317.056 132.868 317.064 132.885 317.069 132.903Z",
    fill: "url(#paint4_linear_9008_207327)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M315.304 153.766L315.322 153.746C315.319 153.749 315.319 153.751 315.317 153.754C315.312 153.759 315.309 153.761 315.304 153.766Z",
    fill: "#F5FAFE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.035 152.088C282.883 149.126 281.351 146.218 279.525 143.549L280.609 142.929C281.224 142.574 281.794 142.143 282.316 141.639C282.65 141.332 282.964 141.008 283.255 140.666L285.124 141.745C286.392 144.239 287.917 146.623 289.631 148.784L284.05 151.979L284.035 152.088Z",
    fill: "url(#paint5_linear_9008_207327)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M283.782 153.422C282.574 150.111 280.893 146.87 278.875 143.926L279.526 143.551C281.351 146.219 282.883 149.128 284.035 152.09L283.845 153.387L283.782 153.422Z",
    fill: "#DCF0FC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.529 154.725H281.456C280.222 151.35 278.498 148.048 276.422 145.061C276.987 144.876 277.559 144.64 278.136 144.346C278.141 144.344 278.149 144.341 278.154 144.336L278.293 144.26L278.875 143.926C280.893 146.87 282.575 150.111 283.783 153.422L281.529 154.725Z",
    fill: "url(#paint6_linear_9008_207327)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M281.455 154.722H279.549C278.301 151.482 276.586 148.33 274.543 145.494C275.161 145.408 275.786 145.266 276.422 145.059C278.498 148.046 280.222 151.347 281.455 154.722Z",
    fill: "#ABC8E4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.146 157.604C268.096 157.493 268.045 157.379 267.992 157.267C265.571 152.081 261.657 147.406 257.276 144.981C255.281 143.876 253.402 143.354 251.726 143.354C249.87 143.354 248.265 143.998 247.039 145.202C247.411 142.974 248.87 139.931 249.786 138.181L250.721 137.643L251.255 137.154C253.478 139.855 256.104 142.148 258.983 143.775C261.338 145.037 264.373 146.281 268.022 146.281C269.493 146.281 271.063 146.078 272.729 145.594C272.833 145.597 272.937 145.599 273.043 145.599C273.537 145.599 274.036 145.566 274.542 145.496C276.586 148.331 278.3 151.483 279.548 154.724H279.47L268.146 157.604Z",
    fill: "url(#paint7_linear_9008_207327)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.807 158.044H263.794C253.152 158.039 246.308 149.933 247.022 145.312C247.024 145.299 247.027 145.286 247.029 145.274C247.032 145.251 247.037 145.228 247.039 145.203C248.265 143.999 249.87 143.355 251.726 143.355C253.402 143.355 255.281 143.877 257.277 144.982C261.657 147.407 265.572 152.082 267.992 157.268C268.045 157.38 268.096 157.494 268.147 157.605L268.144 157.608C266.64 157.907 265.189 158.044 263.807 158.044Z",
    fill: "url(#paint8_linear_9008_207327)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.306 133.922C315.02 133.042 314.683 132.168 314.304 131.304L317.069 132.903L315.306 133.922Z",
    fill: "url(#paint9_linear_9008_207327)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.631 148.784C287.917 146.623 286.393 144.239 285.124 141.745L285.173 141.773L285.613 141.892L285.671 141.89L293.802 141.342L294.182 141.228L296.268 140.022C297.078 141.246 297.972 142.402 298.932 143.458L289.631 148.784ZM285.823 140.111L284.623 139.419L293.351 134.402C293.898 135.811 294.569 137.195 295.339 138.522L293.48 139.597L285.823 140.111Z",
    fill: "url(#paint10_linear_9008_207327)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.474 134.471C313.919 133.06 313.281 131.666 312.564 130.301L314.304 131.304C314.684 132.168 315.021 133.042 315.307 133.922L314.486 134.395L314.474 134.471Z",
    fill: "url(#paint11_linear_9008_207327)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M314.233 135.828C313.45 133.7 312.473 131.599 311.336 129.59L312.564 130.299C313.281 131.665 313.919 133.059 314.473 134.47L314.281 135.8L314.233 135.828Z",
    fill: "#E5F5FD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.965 137.142H311.912C310.678 133.797 308.967 130.526 306.908 127.561C307.098 127.501 307.285 127.435 307.475 127.361L311.337 129.591C312.474 131.6 313.451 133.701 314.233 135.829L311.965 137.142Z",
    fill: "url(#paint12_linear_9008_207327)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M311.911 137.143H309.999C308.827 134.117 307.247 131.166 305.373 128.485C305.446 128.416 305.52 128.348 305.593 128.277C305.76 128.122 305.925 127.963 306.082 127.798C306.355 127.732 306.631 127.654 306.907 127.562C308.966 130.527 310.678 133.798 311.911 137.143Z",
    fill: "#CDE5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.328 138.804C306.792 137.421 306.171 136.045 305.478 134.702L306.536 134.092C306.89 133.886 307.06 133.463 306.939 133.071C306.83 132.711 306.495 132.442 306.131 132.442C306.1 132.442 306.07 132.445 306.037 132.447L304.295 132.564C303.819 131.758 303.318 130.968 302.791 130.197L303.877 129.574C304.412 129.267 304.91 128.905 305.374 128.484C307.247 131.165 308.827 134.117 310 137.142H309.904L307.371 138.508L307.328 138.804Z",
    fill: "url(#paint13_linear_9008_207327)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M307.024 139.995C306.412 138.326 305.68 136.674 304.844 135.07L305.477 134.702C306.171 136.045 306.791 137.421 307.328 138.805L307.166 139.914L307.024 139.995ZM303.464 132.62C303.041 131.923 302.601 131.239 302.143 130.57L302.791 130.197C303.317 130.968 303.819 131.758 304.295 132.564L303.464 132.62Z",
    fill: "#E5F5FD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.847 141.251H304.68C304.074 139.609 303.35 137.985 302.53 136.406L304.844 135.068C305.68 136.672 306.411 138.324 307.024 139.994L304.847 141.251ZM301.682 134.856C301.616 134.742 301.552 134.63 301.487 134.519L302.37 134.458L301.682 134.856ZM300.438 132.821C300.195 132.443 299.945 132.073 299.691 131.704C300.256 131.521 300.826 131.285 301.403 130.992C301.408 130.989 301.413 130.984 301.413 130.984L301.56 130.903L302.142 130.568C302.601 131.237 303.041 131.921 303.464 132.618L300.438 132.821Z",
    fill: "url(#paint14_linear_9008_207327)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M302.773 141.262C302.252 139.922 301.652 138.597 300.981 137.302L302.53 136.408C303.351 137.986 304.075 139.61 304.68 141.252H302.789L302.773 141.262ZM300.135 135.751C299.925 135.382 299.707 135.017 299.484 134.654L301.487 134.52C301.553 134.632 301.616 134.743 301.682 134.857L300.135 135.751ZM298.385 132.959C298.198 132.686 298.006 132.412 297.811 132.143C298.428 132.057 299.056 131.913 299.692 131.705C299.945 132.075 300.196 132.445 300.439 132.822L298.385 132.959Z",
    fill: "#CDE5F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.932 143.458C297.973 142.402 297.079 141.246 296.268 140.023L300.981 137.301C301.652 138.596 302.252 139.921 302.773 141.262L298.932 143.458ZM295.339 138.523C294.569 137.195 293.898 135.811 293.352 134.403L295.243 133.316L297.527 134.636L298.026 134.75L299.484 134.654C299.707 135.016 299.925 135.381 300.135 135.751L295.339 138.523ZM298.178 132.974L297.01 132.3L297.165 132.211C297.38 132.196 297.595 132.173 297.811 132.143C298.005 132.411 298.198 132.685 298.385 132.958L298.178 132.974Z",
    fill: "url(#paint15_linear_9008_207327)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M248.736 171.761C248.714 171.7 248.691 171.642 248.668 171.584C248.749 171.551 248.827 171.513 248.901 171.47L249.855 170.92L250.025 171.019L248.736 171.761Z",
    fill: "#1A58A7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M301.43 163.95C301.473 163.925 301.513 163.9 301.556 163.874L301.559 163.877L301.43 163.95Z",
    fill: "#1A58A7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242.862 162.497C242.783 162.416 242.707 162.335 242.629 162.256L245.11 160.825C245.234 160.756 245.366 160.703 245.505 160.665L245.498 160.789L243.449 161.972C243.224 162.102 243.026 162.279 242.862 162.497Z",
    fill: "#144A90"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M317.092 132.963C317.08 132.925 317.064 132.89 317.052 132.852C317.014 132.745 316.996 132.697 316.996 132.697C316.996 132.697 317.032 132.791 317.092 132.963Z",
    fill: "#9BCEE9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M308.621 159.821C308.672 159.791 308.725 159.76 308.776 159.73L308.778 159.733L308.621 159.821Z",
    fill: "#144A90"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M311.096 158.403C311.131 158.382 311.164 158.362 311.199 158.342C311.164 158.365 311.131 158.385 311.096 158.403Z",
    fill: "#4073B9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M250.025 171.019L249.856 170.92L251.246 170.117C251.246 170.117 251.253 170.124 251.256 170.129L250.722 170.616L250.025 171.019ZM245.498 160.79L245.506 160.666C245.597 160.64 245.688 160.623 245.784 160.607C245.787 160.612 245.789 160.618 245.789 160.623L245.498 160.79Z",
    fill: "#144A90"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M278.137 177.321C278.187 177.291 278.241 177.26 278.291 177.23L278.294 177.233L278.137 177.321Z",
    fill: "#4073B9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.736 173.131C245.229 173.131 244.662 172.981 244.057 172.644C241.854 171.426 240.039 168.35 240.001 165.775C239.98 164.45 240.436 163.518 241.183 163.087L242.629 162.256C242.707 162.334 242.783 162.415 242.862 162.497C242.495 162.986 242.287 163.693 242.302 164.582C242.338 167.08 244.1 170.062 246.237 171.246C246.83 171.575 247.387 171.73 247.885 171.73C248.167 171.73 248.43 171.679 248.668 171.583C248.691 171.641 248.713 171.699 248.736 171.76L246.794 172.88C246.48 173.042 246.126 173.131 245.736 173.131Z",
    fill: "url(#paint16_linear_9008_207327)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313.438 156.438C313.83 155.971 314.19 155.455 314.509 154.892C314.666 154.722 314.817 154.553 314.964 154.383C314.514 155.138 314.01 155.819 313.438 156.438Z",
    fill: "#90C7E9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.778 159.733L308.775 159.73C309.687 159.185 310.495 158.486 311.186 157.645C312.508 156.806 313.596 155.871 314.508 154.891C314.189 155.453 313.829 155.97 313.437 156.436C313.277 156.606 313.115 156.771 312.946 156.933C312.411 157.478 311.837 157.962 311.199 158.342C311.163 158.362 311.13 158.382 311.095 158.402L310.771 158.59L308.778 159.733Z",
    fill: "url(#paint17_linear_9008_207327)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M306.131 160.721C306.516 160.318 306.865 159.887 307.184 159.431L307.258 159.39C307.518 159.238 307.772 159.074 308.015 158.894C309.028 158.711 309.969 158.369 310.82 157.873C310.944 157.799 311.068 157.723 311.187 157.645C310.496 158.486 309.688 159.185 308.777 159.73C308.726 159.76 308.673 159.791 308.622 159.821C307.774 160.252 306.949 160.52 306.131 160.721Z",
    fill: "#70A7D1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.184 159.432C307.29 159.282 307.391 159.13 307.49 158.973C307.667 158.953 307.842 158.925 308.014 158.895C307.771 159.074 307.518 159.239 307.257 159.391L307.184 159.432Z",
    fill: "url(#paint18_linear_9008_207327)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M306.053 160.769C306.521 160.245 306.944 159.649 307.316 158.993C307.374 158.988 307.433 158.98 307.491 158.973C307.392 159.13 307.291 159.282 307.185 159.431C306.866 159.887 306.516 160.318 306.131 160.721C306.119 160.726 306.106 160.729 306.096 160.731L306.053 160.769Z",
    fill: "#90C7E9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.559 163.875L301.557 163.872C303.327 162.813 304.709 161.176 305.61 159.028C305.828 159.04 306.043 159.045 306.254 159.045C306.616 159.045 306.968 159.028 307.315 158.992C306.942 159.648 306.519 160.244 306.051 160.768L305.729 161.075C305.165 161.648 304.555 162.157 303.876 162.547L303.803 162.588L301.559 163.875Z",
    fill: "url(#paint19_linear_9008_207327)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M297.164 165.186L300.018 163.544C301.727 162.564 303.074 160.963 303.945 158.816C304.515 158.925 305.072 158.996 305.611 159.029C304.71 161.178 303.327 162.815 301.557 163.874C301.514 163.899 301.474 163.925 301.431 163.95L301.403 163.965C299.967 164.695 298.577 165.037 297.227 165.148L297.164 165.186Z",
    fill: "#70A7D1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.906 172.805C287.466 167.748 287.018 159.746 284.035 152.089L284.051 151.98L289.631 148.785C292.3 152.147 295.427 154.975 298.762 156.835C300.572 157.843 302.312 158.497 303.945 158.816C303.074 160.963 301.727 162.564 300.018 163.544L297.164 165.186L294.343 166.805L283.906 172.805Z",
    fill: "url(#paint20_linear_9008_207327)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25 173.561C284.964 171.314 285.926 168.053 285.866 163.945C285.815 160.543 285.065 156.945 283.782 153.423L283.845 153.387L284.035 152.09C287.018 159.747 287.466 167.749 283.906 172.806L283.754 172.892C283.589 173.118 283.425 173.343 283.25 173.561Z",
    fill: "#90C7E9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.294 177.232L278.291 177.229C281.674 175.202 283.636 171.082 283.55 165.275C283.499 161.864 282.747 158.254 281.456 154.724H281.53L283.783 153.422C285.067 156.944 285.816 160.542 285.867 163.945C285.928 168.052 284.966 171.313 283.251 173.56C283.041 173.824 282.821 174.08 282.578 174.321C282.054 174.873 281.476 175.347 280.848 175.737L280.61 175.902L278.294 177.232Z",
    fill: "url(#paint21_linear_9008_207327)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M273.062 178.557C272.968 178.557 272.877 178.555 272.783 178.552C274.001 178.195 275.27 177.686 276.586 176.994C279.929 175.076 281.868 171.095 281.785 165.448C281.731 161.981 280.924 158.302 279.549 154.725H281.455C282.747 158.254 283.499 161.865 283.549 165.275C283.636 171.083 281.673 175.203 278.29 177.23C278.24 177.26 278.187 177.291 278.136 177.321C276.379 178.215 274.685 178.557 273.062 178.557Z",
    fill: "#70A7D1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.961 179.207C264.34 179.207 261.319 178.001 258.982 176.749C256.103 175.12 253.513 172.794 251.29 170.095L251.254 170.128C251.252 170.123 251.244 170.115 251.244 170.115L251.373 170.039C253.265 172.297 255.435 174.185 257.729 175.457C259.724 176.559 261.603 177.083 263.279 177.083C267.652 177.083 270.625 173.518 270.534 167.435C270.531 167.151 270.518 166.865 270.503 166.576C270.326 163.644 269.478 160.548 268.146 157.604L279.469 154.723H279.548C280.923 158.3 281.73 161.98 281.783 165.446C281.867 171.094 279.927 175.074 276.585 176.992C275.268 177.684 274 178.193 272.782 178.55C272.726 178.55 272.673 178.548 272.62 178.548C270.974 179.012 269.419 179.207 267.961 179.207ZM245.788 160.621C245.788 160.616 245.785 160.611 245.783 160.606C245.798 160.604 245.813 160.601 245.828 160.599C244.777 157.72 244.096 154.751 243.995 151.832C243.993 151.713 243.99 151.591 243.987 151.472C243.985 151.315 243.982 151.158 243.982 150.996C244 147.408 244.919 142.931 248.272 139.051L249.786 138.18C248.869 139.931 247.411 142.974 247.039 145.201C245.38 146.835 244.418 149.501 244.471 153.002C244.507 155.44 245.031 158.014 245.932 160.54L245.788 160.621Z",
    fill: "url(#paint22_linear_9008_207327)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.281 177.086C261.605 177.086 259.726 176.561 257.731 175.459C255.437 174.187 253.267 172.299 251.375 170.042L256.016 167.364C256.741 166.948 257.184 166.043 257.163 164.756C257.125 162.258 255.363 159.273 253.229 158.09C252.636 157.763 252.077 157.609 251.58 157.609C251.206 157.609 250.866 157.697 250.573 157.864L245.934 160.543C245.032 158.016 244.508 155.442 244.473 153.005C244.42 149.503 245.382 146.837 247.04 145.203C247.038 145.228 247.033 145.251 247.03 145.274C247.028 145.287 247.025 145.299 247.023 145.312C246.309 149.934 253.15 158.039 263.795 158.044H263.808C265.193 158.044 266.638 157.908 268.145 157.609L268.148 157.606C269.479 160.55 270.328 163.647 270.505 166.578C270.52 166.867 270.533 167.153 270.535 167.437C270.626 173.521 267.654 177.086 263.281 177.086Z",
    fill: "url(#paint23_linear_9008_207327)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.901 171.47C249.62 171.049 250.058 170.147 250.038 168.868C250.002 166.369 248.24 163.384 246.103 162.201C245.51 161.874 244.953 161.717 244.454 161.717C244.082 161.717 243.74 161.806 243.449 161.973L245.498 160.79L245.789 160.623L245.933 160.542L250.572 157.863C250.866 157.696 251.205 157.607 251.58 157.607C252.076 157.607 252.636 157.762 253.228 158.089C255.363 159.272 257.125 162.257 257.163 164.755C257.183 166.042 256.74 166.947 256.016 167.363L251.375 170.041L251.245 170.117L249.855 170.92L248.901 171.47Z",
    fill: "url(#paint24_linear_9008_207327)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M247.885 171.732C247.386 171.732 246.829 171.578 246.236 171.248C244.099 170.065 242.337 167.083 242.302 164.584C242.286 163.695 242.494 162.988 242.861 162.499C243.026 162.281 243.223 162.104 243.449 161.975C243.74 161.807 244.082 161.719 244.454 161.719C244.953 161.719 245.51 161.876 246.102 162.203C248.239 163.386 250.002 166.371 250.037 168.869C250.057 170.149 249.619 171.051 248.9 171.471C248.827 171.514 248.748 171.552 248.667 171.585C248.429 171.682 248.166 171.732 247.885 171.732Z",
    fill: "#6898BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.322 153.745C317.036 150.302 317.294 145.87 316.431 141.208C316.444 140.927 316.446 140.64 316.444 140.347C316.418 138.269 316.013 136.082 315.307 133.921L317.069 132.902C317.064 132.885 317.056 132.867 317.051 132.852C317.064 132.89 317.079 132.925 317.092 132.963C317.345 133.68 318.039 135.738 318.441 137.671C318.444 137.684 318.446 137.696 318.449 137.709C318.578 138.327 318.695 139.016 318.791 139.749C318.887 140.531 318.953 141.294 318.981 142.092C319.006 142.984 318.988 143.8 318.92 144.631L318.905 144.781C318.831 145.602 318.705 146.435 318.512 147.271L318.434 147.624L318.363 147.877L318.208 148.422L318.094 148.779L317.97 149.134L317.818 149.559L317.76 149.709L317.702 149.825C317.446 150.444 317.145 151.057 316.795 151.657L316.697 151.832C316.335 152.433 315.909 153.013 315.438 153.583L315.322 153.745Z",
    fill: "url(#paint25_linear_9008_207327)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M314.51 154.891C315.735 152.735 316.404 149.887 316.353 146.446C316.338 145.481 316.27 144.5 316.145 143.512C316.302 142.8 316.399 142.032 316.432 141.209C317.295 145.871 317.037 150.303 315.323 153.746L315.305 153.766L314.966 154.382C314.819 154.552 314.667 154.722 314.51 154.891Z",
    fill: "#94C9E9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.188 157.645C313.069 155.362 314.099 152.02 314.036 147.776C314.034 147.723 314.034 147.672 314.034 147.619C315.034 146.631 315.763 145.247 316.145 143.512C316.269 144.5 316.338 145.48 316.353 146.446C316.404 149.887 315.735 152.735 314.51 154.891C313.598 155.872 312.509 156.806 311.188 157.645Z",
    fill: "url(#paint26_linear_9008_207327)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M308.014 158.894C310.571 157.007 312.156 153.548 312.265 148.828C312.921 148.536 313.513 148.131 314.032 147.619C314.032 147.672 314.032 147.723 314.035 147.776C314.098 152.02 313.068 155.362 311.186 157.645C311.067 157.724 310.943 157.8 310.819 157.873C309.968 158.37 309.026 158.712 308.014 158.894Z",
    fill: "#80B5DB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.49 158.973C309.151 156.348 309.817 153.011 309.673 149.37C310.612 149.36 311.483 149.175 312.266 148.828C312.157 153.549 310.572 157.007 308.014 158.895C307.842 158.925 307.667 158.953 307.49 158.973Z",
    fill: "url(#paint27_linear_9008_207327)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M307.314 158.994C308.525 156.845 309.183 154.01 309.132 150.589C309.127 150.181 309.11 149.768 309.084 149.355C309.254 149.366 309.419 149.371 309.583 149.371H309.672C309.816 153.012 309.15 156.349 307.489 158.974C307.431 158.981 307.373 158.989 307.314 158.994Z",
    fill: "#94C9E9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.254 159.047C306.044 159.047 305.829 159.042 305.611 159.029C306.434 157.07 306.857 154.686 306.817 151.919C306.801 150.911 306.725 149.882 306.591 148.846C307.46 149.137 308.295 149.304 309.085 149.355C309.111 149.768 309.128 150.181 309.133 150.589C309.184 154.01 308.526 156.845 307.315 158.993C306.969 159.029 306.617 159.047 306.254 159.047Z",
    fill: "url(#paint28_linear_9008_207327)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M305.611 159.029C305.072 158.996 304.515 158.925 303.945 158.816C304.695 156.964 305.09 154.706 305.052 152.091C305.032 150.761 304.9 149.398 304.667 148.02C305.323 148.362 305.966 148.635 306.591 148.846C306.726 149.882 306.801 150.911 306.817 151.919C306.857 154.686 306.434 157.07 305.611 159.029Z",
    fill: "#80B5DB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.945 158.816C302.311 158.497 300.572 157.843 298.761 156.835C295.427 154.975 292.3 152.147 289.631 148.785L298.931 143.459C300.549 145.24 302.352 146.738 304.248 147.797C304.388 147.873 304.529 147.949 304.666 148.02C304.899 149.398 305.031 150.761 305.051 152.092C305.089 154.706 304.694 156.964 303.945 158.816Z",
    fill: "url(#paint29_linear_9008_207327)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.43 141.209C316.02 138.987 315.354 136.714 314.473 134.472L314.485 134.396L315.306 133.922C316.012 136.083 316.417 138.27 316.443 140.348C316.445 140.641 316.443 140.928 316.43 141.209Z",
    fill: "url(#paint30_linear_9008_207327)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M316.146 143.513C315.832 140.979 315.174 138.385 314.234 135.831L314.282 135.803L314.475 134.473C315.356 136.715 316.022 138.988 316.432 141.21C316.399 142.033 316.303 142.801 316.146 143.513Z",
    fill: "#96CBEA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.032 147.618C313.959 144.225 313.199 140.642 311.91 137.141H311.963L314.232 135.828C315.171 138.382 315.83 140.977 316.144 143.511C315.761 145.246 315.032 146.63 314.032 147.618Z",
    fill: "url(#paint31_linear_9008_207327)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M312.266 148.826C312.274 148.538 312.274 148.244 312.271 147.947C312.218 144.453 311.398 140.744 310 137.141H311.912C313.201 140.642 313.96 144.225 314.034 147.618C313.514 148.13 312.922 148.535 312.266 148.826Z",
    fill: "#89BDE0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.673 149.369C309.536 145.994 308.706 142.363 307.328 138.803L307.371 138.506L309.903 137.141H309.999C311.397 140.744 312.218 144.453 312.271 147.947C312.273 148.244 312.273 148.538 312.266 148.826C311.483 149.174 310.612 149.359 309.673 149.369Z",
    fill: "url(#paint32_linear_9008_207327)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M309.583 149.371C309.419 149.371 309.254 149.366 309.085 149.355C308.892 146.3 308.168 143.117 307.023 139.996L307.165 139.914L307.327 138.805C308.705 142.365 309.535 145.996 309.672 149.371H309.583Z",
    fill: "#96CBEA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.085 149.356C308.295 149.305 307.46 149.138 306.591 148.847C306.267 146.341 305.611 143.777 304.68 141.253H304.847L307.024 139.996C308.169 143.118 308.893 146.3 309.085 149.356Z",
    fill: "url(#paint33_linear_9008_207327)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M306.592 148.846C305.966 148.635 305.323 148.362 304.667 148.02C304.29 145.777 303.642 143.499 302.773 141.262L302.789 141.252H304.68C305.612 143.776 306.268 146.34 306.592 148.846Z",
    fill: "#89BDE0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.667 148.019C304.53 147.948 304.388 147.872 304.249 147.796C302.352 146.737 300.55 145.24 298.932 143.459L302.773 141.262C303.641 143.499 304.289 145.777 304.667 148.019Z",
    fill: "url(#paint34_linear_9008_207327)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.795 172.882L241.184 163.088L245.111 160.826C245.815 160.423 246.779 160.469 247.848 161.059C250.048 162.28 251.866 165.354 251.904 167.931C251.925 169.256 251.469 170.188 250.722 170.616L246.795 172.882Z",
    fill: "url(#paint35_linear_9008_207327)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M244.057 172.645C241.854 171.426 240.039 168.35 240.001 165.776C239.98 164.45 240.436 163.518 241.183 163.087C241.887 162.684 242.849 162.73 243.918 163.323C246.121 164.542 247.936 167.618 247.974 170.192C247.992 171.365 247.637 172.232 247.037 172.713C246.321 173.286 245.255 173.309 244.057 172.645Z",
    fill: "#4176BB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.069 132.903L314.304 131.304C313.405 129.27 312.258 127.306 310.932 125.525L311.096 125.431C311.605 125.137 312.086 124.792 312.532 124.395C313.398 125.601 314.218 126.895 314.965 128.271L314.968 128.276C314.978 128.294 314.988 128.314 315.001 128.335C315.778 129.774 316.479 131.302 317.069 132.903Z",
    fill: "url(#paint36_linear_9008_207327)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.304 131.303L312.564 130.3C311.797 128.838 310.941 127.414 310.012 126.05L310.931 125.523C312.258 127.305 313.405 129.268 314.304 131.303Z",
    fill: "url(#paint37_linear_9008_207327)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M312.564 130.3L311.336 129.59C310.721 128.506 310.06 127.447 309.361 126.426L310.012 126.051C310.941 127.414 311.797 128.838 312.564 130.3Z",
    fill: "#F0F9FE"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.336 129.59L307.475 127.361C307.854 127.214 308.237 127.044 308.622 126.846L308.776 126.76L309.361 126.426C310.06 127.447 310.721 128.506 311.336 129.59Z",
    fill: "url(#paint38_linear_9008_207327)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M285.614 141.893L285.173 141.774L256.844 125.408C256.422 125.165 256.277 124.625 256.52 124.202C256.763 123.782 257.3 123.642 257.726 123.878L285.824 140.112L293.481 139.598L302.371 134.459L298.026 134.75L297.527 134.636L269.198 118.271C268.778 118.027 268.634 117.488 268.877 117.065C269.12 116.644 269.659 116.502 270.079 116.74L298.178 132.974L306.037 132.447C306.437 132.397 306.82 132.68 306.939 133.071C307.06 133.463 306.89 133.886 306.536 134.092L294.182 141.229L293.802 141.343L285.672 141.891L285.614 141.893Z",
    fill: "#8CA2BA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.316 120.782V120.779C316.405 119.507 317.195 118.139 317.76 116.735L317.828 116.561C317.924 116.31 318.013 116.059 318.094 115.808L318.241 115.339C318.309 115.111 318.375 114.881 318.433 114.653L318.497 114.394C319.299 110.979 319.001 107.578 318.522 105.098C319.309 109.18 319.623 115.75 315.316 120.782ZM318.507 105.027C318.507 105.024 318.507 105.019 318.504 105.017C318.507 105.019 318.507 105.022 318.507 105.027Z",
    fill: "url(#paint39_linear_9008_207327)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M286.33 81.7596C287.72 81.0603 291.954 78.9319 299.127 82.7934C314.038 90.8179 323.696 117.653 311.096 125.432L286.33 81.7596Z",
    fill: "#EFF7FD"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.779 126.76L311.096 125.43L310.932 125.523L310.012 126.05L309.362 126.425L308.779 126.76ZM311.096 125.43C311.775 125.039 312.385 124.533 312.947 123.958C313.117 123.798 313.279 123.631 313.438 123.461C313.236 123.699 313.026 123.927 312.805 124.14C312.717 124.226 312.625 124.31 312.532 124.393C312.086 124.791 311.605 125.136 311.096 125.43Z",
    fill: "url(#paint40_linear_9008_207327)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M295.784 125.839C286.005 120.346 278.379 107.436 278.042 95.8063C277.946 92.4895 278.569 86.4389 283.812 83.2007C286.945 81.4017 291.231 81.607 295.987 84.2396C305.783 89.6644 313.863 103.347 314.035 114.805C314.124 120.698 312.098 124.856 308.622 126.848C303.801 129.303 299.428 127.714 295.784 125.839Z",
    fill: "#B9CDE4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M279.088 85.9167C280.478 85.2097 284.714 83.0662 291.903 86.9353C306.814 94.9598 316.476 121.798 303.877 129.574L279.088 85.9167Z",
    fill: "#EFF7FD"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.877 129.573C304.556 129.183 305.166 128.676 305.73 128.101L306.052 127.797C305.905 127.964 305.751 128.124 305.594 128.276C305.52 128.347 305.447 128.415 305.373 128.484C304.91 128.904 304.411 129.266 303.877 129.573Z",
    fill: "url(#paint41_linear_9008_207327)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M288.568 129.981C278.789 124.488 271.16 111.578 270.823 99.9478C270.727 96.6311 271.35 90.5804 276.596 87.3422C279.728 85.5458 284.013 85.7485 288.768 88.3811C298.564 93.8059 306.644 107.491 306.816 118.946C306.905 124.84 304.879 128.998 301.403 130.992C296.584 133.444 292.209 131.856 288.568 129.981Z",
    fill: "#B9CDE4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.904 139.83L297.228 132.176L297.165 132.211L297.01 132.3L295.243 133.316L293.351 134.403L284.623 139.42L283.904 139.83Z",
    fill: "url(#paint42_linear_9008_207327)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M255.936 99.4157L256.006 99.175C257.546 98.4098 261.729 96.5678 268.641 100.29C283.489 108.279 293.129 134.924 280.77 142.827L280.519 142.766L255.936 99.4157Z",
    fill: "#EFF7FD"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.293 144.259L280.61 142.929L279.526 143.549L278.875 143.924L278.293 144.259ZM280.61 142.929L280.848 142.761C281.476 142.374 282.053 141.897 282.577 141.345C282.818 141.107 283.038 140.853 283.248 140.59C282.96 140.97 282.648 141.32 282.316 141.639C281.795 142.143 281.225 142.574 280.61 142.929Z",
    fill: "url(#paint43_linear_9008_207327)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M265.302 143.335C255.528 137.844 247.899 124.932 247.56 113.302C247.463 109.985 248.084 103.937 253.33 100.699C256.46 98.8998 260.746 99.105 265.502 101.738C275.298 107.162 283.378 120.845 283.55 132.3C283.639 138.196 281.613 142.352 278.137 144.346C273.318 146.798 268.945 145.212 265.302 143.335Z",
    fill: "#B9CDE4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.022 146.282C264.373 146.282 261.337 145.037 258.982 143.776C256.103 142.149 253.478 139.856 251.254 137.155L251.29 137.122C253.513 139.82 256.103 142.149 258.982 143.776C261.319 145.03 264.34 146.236 267.961 146.236C269.419 146.236 270.972 146.041 272.62 145.575C272.673 145.577 272.729 145.577 272.782 145.58C272.764 145.585 272.747 145.59 272.729 145.595C271.063 146.079 269.493 146.282 268.022 146.282ZM245.783 127.633C245.689 127.379 245.598 127.124 245.512 126.87C244.613 124.233 244.084 121.521 243.995 118.858C244.096 121.777 244.777 124.747 245.828 127.628C245.813 127.628 245.798 127.63 245.783 127.633ZM243.982 118.025C243.993 115.711 244.357 113.023 245.509 110.368C246.246 108.67 247.307 106.983 248.801 105.417L248.971 105.318C245.046 109.359 244 114.196 243.982 118.025ZM247.092 111.944C247.58 109.501 249.229 106.233 250.059 104.689C249.231 106.233 247.58 109.501 247.092 111.944Z",
    fill: "url(#paint44_linear_9008_207327)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M246.236 138.276C244.099 137.093 242.337 134.108 242.301 131.61C242.263 129.111 243.965 128.047 246.102 129.228C248.239 130.411 250.001 133.396 250.037 135.894C250.075 138.393 248.373 139.459 246.236 138.276Z",
    fill: "#ABBCCB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M317.047 99.8622C315.964 96.9509 314.525 94.2879 312.902 91.9442C312.9 91.9416 312.9 91.9391 312.897 91.9366C312.89 91.9264 312.882 91.9163 312.874 91.9062C312.872 91.9011 312.869 91.896 312.864 91.8909C312.859 91.8833 312.852 91.8732 312.847 91.8631C312.841 91.858 312.836 91.8504 312.831 91.8453C312.829 91.8377 312.821 91.8301 312.816 91.8225C312.811 91.8149 312.806 91.8073 312.801 91.7997C312.796 91.7921 312.791 91.7845 312.786 91.7795C312.781 91.7693 312.773 91.7592 312.768 91.7516C312.763 91.7465 312.76 91.7415 312.758 91.7364C312.75 91.7263 312.743 91.7136 312.733 91.7035C312.73 91.7009 312.728 91.6959 312.725 91.6933C312.717 91.6807 312.71 91.668 312.7 91.6553C312.7 91.6527 312.697 91.6502 312.695 91.6477C312.684 91.635 312.674 91.6223 312.667 91.6071C312.664 91.6071 312.664 91.6046 312.664 91.6046C312.568 91.4678 312.469 91.3335 312.373 91.1992C314.214 93.7178 315.85 96.6367 317.047 99.8622Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.318 120.779C315.32 120.777 315.32 120.774 315.323 120.772L315.439 120.61C315.91 120.042 316.336 119.459 316.698 118.859L316.796 118.684C317.146 118.084 317.447 117.473 317.703 116.852L317.761 116.736C317.196 118.139 316.406 119.507 315.318 120.779ZM317.761 116.736L317.819 116.586L317.971 116.16L318.095 115.808C318.014 116.059 317.926 116.31 317.829 116.561L317.761 116.736ZM318.095 115.808L318.209 115.451L318.364 114.904L318.435 114.653C318.376 114.881 318.311 115.111 318.242 115.339L318.095 115.808ZM318.435 114.653L318.513 114.298C318.706 113.462 318.832 112.631 318.906 111.81L318.921 111.66C318.989 110.827 319.007 110.011 318.982 109.119C318.954 108.323 318.888 107.558 318.792 106.775C318.695 106.043 318.579 105.356 318.45 104.736C318.465 104.812 318.48 104.885 318.495 104.961V104.966C318.498 104.974 318.5 104.981 318.5 104.991C318.503 104.991 318.503 104.994 318.503 104.994C318.503 105.002 318.506 105.009 318.506 105.017C318.508 105.019 318.508 105.024 318.508 105.027C318.511 105.032 318.511 105.04 318.513 105.045C318.513 105.05 318.513 105.055 318.516 105.06C318.516 105.062 318.516 105.067 318.518 105.07C318.518 105.078 318.521 105.085 318.521 105.093C318.521 105.095 318.523 105.095 318.523 105.098C319.002 107.578 319.301 110.979 318.498 114.394L318.435 114.653ZM318.442 104.7C318.04 102.762 317.343 100.704 317.093 99.9872C317.571 101.295 317.979 102.653 318.3 104.051C318.351 104.267 318.397 104.482 318.442 104.7ZM317.07 99.9315C315.986 96.9923 314.538 94.3065 312.902 91.945C314.525 94.2888 315.963 96.9518 317.047 99.8631C317.055 99.8834 317.062 99.9061 317.07 99.9315ZM312.864 91.8918C312.859 91.8816 312.851 91.874 312.846 91.8639C312.851 91.874 312.859 91.8842 312.864 91.8918ZM312.831 91.8462C312.826 91.8386 312.821 91.831 312.816 91.8234C312.821 91.831 312.829 91.8386 312.831 91.8462ZM312.7 91.6561C312.697 91.6536 312.697 91.6511 312.694 91.6485C312.697 91.6511 312.7 91.6536 312.7 91.6561Z",
    fill: "url(#paint45_linear_9008_207327)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M315.305 120.792L315.322 120.771C315.32 120.774 315.32 120.777 315.317 120.779C315.315 120.784 315.31 120.789 315.305 120.792Z",
    fill: "#F5FAFE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.035 119.115C282.845 116.06 281.25 113.057 279.346 110.321L280.609 109.596C281.224 109.244 281.794 108.813 282.316 108.309C282.693 107.964 283.04 107.594 283.362 107.209L284.742 108.005C286.081 110.777 287.739 113.429 289.631 115.811L284.05 119.006L284.035 119.115Z",
    fill: "url(#paint46_linear_9008_207327)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M283.782 120.448C282.539 117.04 280.794 113.703 278.695 110.691L279.346 110.318C281.25 113.055 282.845 116.057 284.035 119.113L283.845 120.41L283.782 120.448Z",
    fill: "#DCF0FC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.529 121.751H281.456C280.182 118.265 278.382 114.857 276.217 111.791C276.847 111.599 277.488 111.343 278.136 111.013L278.293 110.925L278.696 110.691C280.795 113.704 282.539 117.041 283.783 120.449L281.529 121.751Z",
    fill: "url(#paint47_linear_9008_207327)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M281.456 121.751H279.547C278.253 118.384 276.452 115.11 274.303 112.194C274.931 112.12 275.569 111.989 276.217 111.791C278.382 114.857 280.182 118.265 281.456 121.751Z",
    fill: "#ABC8E4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.146 124.633C268.096 124.519 268.045 124.407 267.992 124.293C265.571 119.109 261.657 114.434 257.276 112.007C255.281 110.905 253.402 110.38 251.726 110.38C249.87 110.38 248.265 111.024 247.039 112.23C247.054 112.136 247.072 112.04 247.092 111.944C247.581 109.501 249.232 106.232 250.06 104.689L250.721 104.309L251.255 103.82C253.478 106.521 256.104 108.814 258.983 110.441C261.338 111.703 264.373 112.947 268.022 112.947C269.493 112.95 271.063 112.747 272.729 112.26C272.833 112.265 272.937 112.265 273.043 112.265C273.459 112.265 273.879 112.243 274.302 112.194C276.451 115.111 278.252 118.385 279.546 121.752H279.47L268.146 124.633Z",
    fill: "url(#paint48_linear_9008_207327)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.807 125.072H263.795C253.274 125.067 246.465 117.146 247.002 112.502C247.01 112.433 247.017 112.367 247.03 112.299C247.033 112.276 247.038 112.253 247.04 112.231C248.266 111.024 249.871 110.381 251.727 110.381C253.403 110.381 255.282 110.905 257.277 112.008C261.658 114.435 265.572 119.11 267.993 124.294C268.046 124.408 268.097 124.519 268.147 124.633C266.643 124.935 265.19 125.072 263.807 125.072Z",
    fill: "url(#paint49_linear_9008_207327)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M312.902 91.9442C312.9 91.9416 312.897 91.9391 312.897 91.9366C312.9 91.9391 312.9 91.9416 312.902 91.9442ZM312.786 91.7795C312.781 91.7693 312.773 91.7617 312.768 91.7516C312.773 91.7592 312.781 91.7693 312.786 91.7795ZM312.758 91.7364C312.748 91.7263 312.743 91.7161 312.733 91.7035C312.743 91.7136 312.75 91.7263 312.758 91.7364Z",
    fill: "#ECF8FE"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.308 100.947C315.022 100.067 314.685 99.1933 314.305 98.3318L317.07 99.9306L315.308 100.947ZM317.07 99.9306C315.87 96.6773 314.224 93.7355 312.373 91.1992C312.469 91.3335 312.568 91.4678 312.664 91.6046C312.664 91.6046 312.664 91.6071 312.667 91.6071C312.674 91.6223 312.684 91.635 312.695 91.6477C312.697 91.6502 312.697 91.6527 312.7 91.6553C312.71 91.668 312.717 91.6807 312.725 91.6933C312.728 91.6959 312.73 91.7009 312.733 91.7035C312.743 91.7161 312.748 91.7263 312.758 91.7364C312.76 91.7415 312.763 91.7465 312.768 91.7516C312.773 91.7617 312.781 91.7693 312.786 91.7795C312.791 91.7845 312.796 91.7921 312.801 91.7997L312.831 91.8453C312.836 91.8504 312.841 91.858 312.847 91.8631C312.852 91.8732 312.859 91.8808 312.864 91.8909C312.869 91.896 312.872 91.9011 312.874 91.9062C312.882 91.9163 312.89 91.9264 312.897 91.9366C312.897 91.9391 312.9 91.9416 312.902 91.9442C314.538 94.3057 315.986 96.9915 317.07 99.9306Z",
    fill: "url(#paint50_linear_9008_207327)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.632 115.808C287.74 113.427 286.082 110.774 284.742 108.002L285.58 108.486L286.021 108.602L286.079 108.6L294.207 108.055L294.589 107.939L296.233 106.991C297.05 108.235 297.959 109.411 298.932 110.485L289.632 115.808ZM286.228 106.824L284.785 105.99L293.237 101.133C293.797 102.62 294.496 104.087 295.306 105.488L293.885 106.309L286.228 106.824Z",
    fill: "url(#paint51_linear_9008_207327)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.474 101.497C313.922 100.088 313.281 98.6919 312.564 97.3262L314.304 98.3321C314.684 99.1936 315.021 100.068 315.307 100.947L314.486 101.423L314.474 101.497Z",
    fill: "url(#paint52_linear_9008_207327)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M314.233 102.855C313.45 100.727 312.473 98.6265 311.336 96.6172L312.564 97.3266C313.281 98.6924 313.921 100.088 314.473 101.497L314.281 102.83L314.233 102.855Z",
    fill: "#E5F5FD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.965 104.167H311.912C310.638 100.711 308.85 97.3332 306.703 94.2927C306.832 94.2547 306.964 94.2116 307.096 94.166L311.337 96.6162C312.474 98.6255 313.451 100.726 314.233 102.854L311.965 104.167Z",
    fill: "url(#paint53_linear_9008_207327)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M311.912 104.167H310C308.795 101.058 307.159 98.0278 305.217 95.2888C305.346 95.1773 305.47 95.0632 305.592 94.9442C305.761 94.7896 305.926 94.6274 306.085 94.4627C306.29 94.4146 306.495 94.3563 306.703 94.293C308.85 97.3335 310.638 100.711 311.912 104.167Z",
    fill: "#CDE5F5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.329 105.83C306.784 104.426 306.154 103.032 305.447 101.669L306.944 100.805C307.298 100.597 307.468 100.177 307.346 99.784C307.237 99.4242 306.923 99.1531 306.546 99.1531C306.511 99.1531 306.478 99.1556 306.445 99.1607L304.133 99.3153C303.652 98.5146 303.143 97.7316 302.611 96.9664L303.877 96.2392C304.351 95.9681 304.799 95.6514 305.217 95.2891C307.159 98.0281 308.795 101.058 310 104.167H309.904L307.372 105.533L307.329 105.83Z",
    fill: "url(#paint54_linear_9008_207327)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M307.024 107.021C306.404 105.331 305.66 103.659 304.811 102.037L305.447 101.67C306.153 103.033 306.784 104.426 307.328 105.83L307.166 106.94L307.024 107.021ZM303.297 99.3714C302.872 98.6796 302.426 98.0006 301.963 97.3393L302.611 96.9668C303.143 97.732 303.652 98.5149 304.133 99.3156L303.297 99.3714Z",
    fill: "#E5F5FD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.847 108.281H304.68C304.067 106.616 303.333 104.972 302.498 103.373L304.812 102.037C305.66 103.659 306.404 105.331 307.025 107.021L304.847 108.281ZM301.649 101.827C301.543 101.642 301.434 101.457 301.325 101.272L302.776 101.176L301.649 101.827ZM300.262 99.5772C300.009 99.192 299.75 98.8119 299.484 98.4395C300.115 98.2444 300.755 97.9885 301.404 97.6591C301.414 97.654 301.424 97.649 301.434 97.6414L301.561 97.5704L301.963 97.3398C302.427 98.0012 302.872 98.6802 303.298 99.3719L300.262 99.5772Z",
    fill: "url(#paint55_linear_9008_207327)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M302.774 108.286C302.244 106.926 301.634 105.58 300.951 104.265L302.498 103.371C303.333 104.97 304.068 106.614 304.68 108.279H302.789L302.774 108.286ZM300.102 102.72C299.849 102.276 299.586 101.838 299.315 101.407L301.325 101.27C301.434 101.455 301.543 101.64 301.649 101.825L300.102 102.72ZM298.586 99.6867L297.902 99.2914C297.791 99.1394 297.682 98.9899 297.57 98.8379C298.198 98.7644 298.836 98.6351 299.485 98.4375C299.75 98.81 300.009 99.19 300.262 99.5752L298.586 99.6867Z",
    fill: "#CDE5F5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.931 110.488C297.959 109.413 297.05 108.238 296.232 106.994L300.949 104.267C301.633 105.582 302.243 106.928 302.772 108.288L298.931 110.488ZM295.305 105.491C294.495 104.09 293.796 102.623 293.236 101.135L295.404 99.8913L297.933 101.353L298.435 101.467L299.313 101.409C299.584 101.84 299.848 102.278 300.101 102.722L295.305 105.491ZM297.9 99.2934L297.179 98.8778C297.308 98.8677 297.44 98.855 297.569 98.8398C297.68 98.9919 297.789 99.1414 297.9 99.2934Z",
    fill: "url(#paint56_linear_9008_207327)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M241.373 136.999C240.55 135.697 240.021 134.179 240.001 132.803C239.98 131.478 240.436 130.543 241.183 130.115L241.373 130.006V136.999Z",
    fill: "#9BCEE9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M245.513 140.15C245.065 140.112 244.576 139.96 244.057 139.674C243.032 139.106 242.09 138.136 241.373 137.001V130.008L245.11 127.854C245.234 127.78 245.371 127.73 245.513 127.692V127.811L243.459 128.997C242.728 129.41 242.282 130.317 242.302 131.609C242.335 133.818 243.718 136.408 245.513 137.797V140.15ZM243.996 118.859C243.994 118.74 243.991 118.618 243.989 118.499C243.991 118.621 243.994 118.74 243.996 118.859Z",
    fill: "#144A90"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M317.092 99.9862C317.077 99.9456 317.062 99.9026 317.044 99.862C317.011 99.7683 316.996 99.7227 316.996 99.7227C316.996 99.7227 317.032 99.819 317.092 99.9862Z",
    fill: "#9BCEE9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M245.736 140.16C245.663 140.16 245.59 140.157 245.514 140.15V137.796C245.749 137.976 245.992 138.138 246.238 138.275C246.83 138.602 247.387 138.756 247.886 138.756C248.124 138.756 248.35 138.721 248.557 138.652C248.41 138.812 248.266 138.974 248.129 139.136L246.795 139.906C246.481 140.071 246.126 140.16 245.736 140.16ZM245.514 127.81V127.691C245.602 127.666 245.691 127.648 245.785 127.633C245.787 127.638 245.79 127.645 245.79 127.651L245.514 127.81Z",
    fill: "#345DAB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.129 139.136C248.266 138.974 248.41 138.812 248.557 138.652C248.595 138.64 248.633 138.625 248.671 138.609C248.534 138.756 248.402 138.906 248.273 139.053L248.129 139.136Z",
    fill: "url(#paint57_linear_9008_207327)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.154 144.337C278.2 144.311 278.245 144.283 278.291 144.258L278.294 144.26L278.154 144.337Z",
    fill: "url(#paint58_linear_9008_207327)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.787 138.179C249.838 138.083 249.888 137.987 249.934 137.898L251.246 137.141C251.248 137.146 251.256 137.153 251.256 137.153L250.721 137.642L249.787 138.179Z",
    fill: "url(#paint59_linear_9008_207327)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.412 130.986C301.46 130.958 301.508 130.93 301.556 130.902L301.559 130.905L301.412 130.986Z",
    fill: "url(#paint60_linear_9008_207327)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.273 139.051C248.403 138.904 248.534 138.755 248.671 138.608C248.747 138.577 248.823 138.539 248.894 138.499L249.934 137.898C249.889 137.987 249.838 138.083 249.788 138.18L248.273 139.051Z",
    fill: "url(#paint61_linear_9008_207327)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.621 126.847C308.672 126.819 308.725 126.788 308.776 126.758L308.778 126.76L308.621 126.847Z",
    fill: "url(#paint62_linear_9008_207327)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M313.438 123.463C313.83 122.996 314.19 122.479 314.509 121.917C314.666 121.75 314.817 121.58 314.962 121.41C314.514 122.165 314.01 122.844 313.438 123.463Z",
    fill: "#90C7E9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.778 126.763L308.775 126.76C309.687 126.213 310.495 125.516 311.186 124.675C312.508 123.834 313.596 122.899 314.508 121.918C314.189 122.48 313.829 122.997 313.437 123.464C313.277 123.633 313.115 123.801 312.946 123.96C312.384 124.535 311.773 125.042 311.095 125.432L308.778 126.763Z",
    fill: "url(#paint63_linear_9008_207327)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M306.131 127.75C306.516 127.344 306.865 126.914 307.184 126.46L307.258 126.417C307.518 126.268 307.772 126.1 308.015 125.92C309.028 125.741 309.969 125.396 310.82 124.902C310.944 124.826 311.068 124.75 311.187 124.674C310.496 125.515 309.688 126.212 308.777 126.759C308.726 126.79 308.673 126.82 308.622 126.848C307.774 127.281 306.949 127.55 306.131 127.75Z",
    fill: "#70A7D1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.184 126.46C307.29 126.31 307.391 126.156 307.49 126.001C307.667 125.978 307.842 125.953 308.014 125.92C307.771 126.1 307.518 126.267 307.257 126.417L307.184 126.46Z",
    fill: "url(#paint64_linear_9008_207327)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M306.053 127.796C306.521 127.269 306.944 126.677 307.316 126.018C307.374 126.013 307.433 126.005 307.491 126C307.392 126.155 307.291 126.309 307.185 126.459C306.866 126.912 306.516 127.343 306.131 127.748C306.119 127.751 306.106 127.753 306.096 127.756L306.053 127.796Z",
    fill: "#90C7E9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.559 130.905L301.557 130.902C303.327 129.84 304.709 128.206 305.61 126.055C305.828 126.068 306.043 126.075 306.254 126.075C306.616 126.075 306.968 126.058 307.315 126.02C306.942 126.678 306.519 127.271 306.051 127.798L305.729 128.102C305.165 128.677 304.555 129.184 303.876 129.574L302.142 130.57L301.559 130.905Z",
    fill: "url(#paint65_linear_9008_207327)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M297.227 132.176L300.017 130.572C301.726 129.592 303.073 127.988 303.944 125.842C304.514 125.953 305.071 126.024 305.61 126.055C304.709 128.206 303.326 129.84 301.556 130.902C301.508 130.93 301.46 130.958 301.412 130.985L301.402 130.993C299.966 131.723 298.576 132.062 297.227 132.176Z",
    fill: "#70A7D1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.904 139.829C287.467 134.774 287.019 126.77 284.036 119.113L284.051 119.004L289.632 115.809C292.301 119.173 295.428 122.001 298.762 123.858C300.573 124.869 302.312 125.521 303.946 125.84C303.074 127.986 301.727 129.59 300.018 130.57L297.228 132.174L283.904 139.829Z",
    fill: "url(#paint66_linear_9008_207327)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M283.248 140.59C284.962 138.342 285.927 135.079 285.866 130.969C285.816 127.569 285.066 123.968 283.782 120.449L283.846 120.411L284.036 119.113C287.018 126.77 287.466 134.775 283.904 139.829L283.754 139.918C283.59 140.144 283.423 140.369 283.248 140.59Z",
    fill: "#90C7E9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.294 144.259L278.291 144.257C281.674 142.227 283.636 138.107 283.55 132.3C283.499 128.889 282.747 125.281 281.456 121.752H281.53L283.783 120.449C285.067 123.969 285.816 127.569 285.867 130.969C285.928 135.079 284.963 138.343 283.249 140.59C283.039 140.854 282.818 141.107 282.578 141.345C282.054 141.898 281.476 142.374 280.848 142.762L280.61 142.929L278.294 144.259Z",
    fill: "url(#paint67_linear_9008_207327)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M273.064 145.582C272.971 145.582 272.877 145.582 272.783 145.58C274.001 145.22 275.27 144.711 276.586 144.021C279.929 142.103 281.868 138.12 281.785 132.472C281.731 129.006 280.924 125.327 279.546 121.752H281.455C282.747 125.282 283.499 128.89 283.549 132.3C283.636 138.108 281.673 142.227 278.29 144.257C278.245 144.282 278.199 144.31 278.154 144.336L278.136 144.346C276.381 145.24 274.687 145.582 273.064 145.582Z",
    fill: "#70A7D1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.961 146.236C264.34 146.236 261.319 145.03 258.982 143.776C256.103 142.149 253.513 139.82 251.29 137.122L251.254 137.155C251.254 137.155 251.247 137.147 251.244 137.142L251.373 137.069C253.265 139.324 255.435 141.214 257.729 142.483C259.724 143.588 261.603 144.11 263.279 144.11C267.652 144.11 270.625 140.548 270.534 134.461C270.531 134.178 270.518 133.891 270.503 133.605C270.326 130.671 269.478 127.577 268.146 124.633L279.469 121.752H279.545C280.923 125.327 281.73 129.006 281.783 132.472C281.867 138.12 279.927 142.103 276.585 144.021C275.268 144.711 274 145.22 272.782 145.58C272.729 145.577 272.673 145.577 272.62 145.575C270.972 146.041 269.419 146.236 267.961 146.236ZM245.788 127.651C245.788 127.646 245.785 127.638 245.783 127.633C245.798 127.63 245.813 127.628 245.828 127.628C244.777 124.747 244.096 121.777 243.995 118.858C243.993 118.739 243.99 118.62 243.987 118.499C243.985 118.341 243.982 118.184 243.982 118.025C244 114.196 245.046 109.359 248.971 105.318L250.059 104.689C249.229 106.233 247.58 109.501 247.092 111.944C247.072 112.04 247.054 112.136 247.039 112.23C245.38 113.862 244.418 116.53 244.471 120.029C244.507 122.466 245.031 125.043 245.932 127.567L245.788 127.651Z",
    fill: "url(#paint68_linear_9008_207327)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.281 144.111C261.605 144.111 259.726 143.589 257.731 142.484C255.437 141.214 253.267 139.324 251.375 137.069L256.016 134.391C256.741 133.975 257.184 133.068 257.163 131.784C257.125 129.285 255.363 126.301 253.229 125.117C252.636 124.79 252.077 124.633 251.58 124.633C251.206 124.633 250.866 124.722 250.573 124.889L245.934 127.567C245.032 125.044 244.508 122.467 244.473 120.029C244.42 116.53 245.382 113.862 247.04 112.23C247.038 112.253 247.033 112.276 247.03 112.299C247.018 112.367 247.01 112.433 247.002 112.502C246.466 117.146 253.274 125.069 263.795 125.072H263.808C265.193 125.072 266.641 124.935 268.145 124.633C269.477 127.578 270.328 130.671 270.505 133.605C270.52 133.892 270.533 134.178 270.535 134.462C270.626 140.548 267.654 144.111 263.281 144.111Z",
    fill: "url(#paint69_linear_9008_207327)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.893 138.5C249.617 138.085 250.058 137.178 250.037 135.893C250.002 133.395 248.239 130.41 246.102 129.227C245.51 128.9 244.953 128.745 244.454 128.745C244.084 128.745 243.75 128.831 243.459 128.996L245.512 127.81L245.788 127.651L245.933 127.567L250.572 124.889C250.865 124.721 251.205 124.633 251.579 124.633C252.076 124.633 252.635 124.79 253.228 125.117C255.362 126.3 257.124 129.285 257.162 131.783C257.183 133.068 256.74 133.975 256.015 134.39L251.374 137.069L251.245 137.142L249.933 137.9L248.893 138.5Z",
    fill: "url(#paint70_linear_9008_207327)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M247.885 138.757C247.386 138.757 246.829 138.603 246.236 138.276C245.991 138.139 245.748 137.977 245.512 137.797C243.717 136.408 242.334 133.819 242.301 131.609C242.281 130.317 242.727 129.41 243.459 128.997C243.75 128.832 244.084 128.746 244.454 128.746C244.952 128.746 245.51 128.901 246.102 129.228C248.239 130.411 250.001 133.396 250.037 135.894C250.057 137.179 249.617 138.086 248.892 138.501C248.821 138.542 248.746 138.58 248.67 138.61C248.632 138.625 248.594 138.641 248.556 138.653C248.348 138.722 248.123 138.757 247.885 138.757Z",
    fill: "#6898BA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M317.094 99.9897C317.078 99.9484 317.063 99.9071 317.047 99.8633C317.066 99.9046 317.078 99.9484 317.094 99.9897Z",
    fill: "#9BCEE9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.322 120.772C317.039 117.329 317.294 112.897 316.431 108.237C316.444 107.956 316.446 107.667 316.444 107.373C316.418 105.298 316.013 103.112 315.307 100.948L317.069 99.9317C317.061 99.9063 317.054 99.8836 317.046 99.8633C317.061 99.9064 317.077 99.9469 317.092 99.9874C317.342 100.704 318.039 102.762 318.441 104.7C318.444 104.713 318.446 104.726 318.449 104.736C318.578 105.357 318.695 106.043 318.791 106.775C318.887 107.558 318.953 108.324 318.981 109.119C319.006 110.011 318.988 110.827 318.92 111.661L318.905 111.81C318.831 112.631 318.705 113.462 318.512 114.298L318.434 114.653L318.363 114.904L318.208 115.451L318.094 115.808L317.97 116.161L317.818 116.586L317.76 116.736L317.702 116.852C317.446 117.473 317.145 118.084 316.795 118.684L316.697 118.859C316.335 119.46 315.909 120.042 315.438 120.61L315.322 120.772Z",
    fill: "url(#paint71_linear_9008_207327)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M314.51 121.916C315.735 119.763 316.404 116.915 316.353 113.474C316.338 112.508 316.27 111.528 316.145 110.537C316.302 109.828 316.399 109.06 316.432 108.236C317.295 112.896 317.039 117.328 315.323 120.771L315.305 120.791L314.966 121.407L314.963 121.409C314.819 121.579 314.667 121.749 314.51 121.916Z",
    fill: "#94C9E9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.188 124.673C313.069 122.388 314.099 119.046 314.036 114.804C314.034 114.751 314.034 114.698 314.034 114.644C315.034 113.659 315.763 112.273 316.145 110.537C316.269 111.528 316.338 112.508 316.353 113.474C316.404 116.915 315.735 119.763 314.51 121.916C313.598 122.897 312.509 123.832 311.188 124.673Z",
    fill: "url(#paint72_linear_9008_207327)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M308.014 125.92C310.571 124.035 312.156 120.574 312.265 115.853C312.921 115.562 313.511 115.156 314.032 114.645C314.032 114.698 314.032 114.751 314.035 114.804C314.098 119.046 313.068 122.388 311.186 124.673C311.067 124.749 310.943 124.825 310.819 124.901C309.968 125.395 309.026 125.74 308.014 125.92Z",
    fill: "#80B5DB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.49 125.999C309.154 123.374 309.817 120.035 309.673 116.396C310.612 116.384 311.483 116.199 312.266 115.852C312.157 120.572 310.572 124.033 308.014 125.918C307.842 125.951 307.667 125.977 307.49 125.999Z",
    fill: "url(#paint73_linear_9008_207327)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M307.314 126.017C308.525 123.869 309.183 121.033 309.132 117.615C309.127 117.205 309.11 116.794 309.084 116.379C309.254 116.392 309.421 116.397 309.586 116.397H309.672C309.816 120.035 309.153 123.375 307.489 126C307.431 126.005 307.373 126.012 307.314 126.017Z",
    fill: "#94C9E9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.254 126.075C306.044 126.075 305.829 126.067 305.611 126.054C306.434 124.098 306.857 121.714 306.817 118.947C306.801 117.936 306.725 116.91 306.591 115.871C307.46 116.165 308.295 116.332 309.085 116.38C309.111 116.796 309.128 117.206 309.133 117.617C309.184 121.035 308.526 123.87 307.315 126.019C306.969 126.057 306.617 126.075 306.254 126.075Z",
    fill: "url(#paint74_linear_9008_207327)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M305.611 126.054C305.072 126.023 304.515 125.952 303.945 125.841C304.695 123.989 305.09 121.731 305.052 119.119C305.032 117.786 304.9 116.423 304.667 115.047C305.323 115.386 305.966 115.66 306.591 115.87C306.726 116.909 306.801 117.935 306.817 118.946C306.857 121.713 306.434 124.098 305.611 126.054Z",
    fill: "#80B5DB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.945 125.841C302.311 125.522 300.572 124.871 298.761 123.86C295.427 122.002 292.3 119.175 289.631 115.81L298.931 110.486C300.549 112.268 302.352 113.763 304.248 114.822C304.388 114.9 304.529 114.974 304.666 115.047C304.899 116.423 305.031 117.786 305.051 119.119C305.089 121.731 304.694 123.989 303.945 125.841Z",
    fill: "url(#paint75_linear_9008_207327)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.43 108.237C316.02 106.015 315.354 103.739 314.473 101.497L314.485 101.424L315.306 100.947C316.012 103.111 316.417 105.298 316.443 107.373C316.445 107.667 316.443 107.956 316.43 108.237Z",
    fill: "url(#paint76_linear_9008_207327)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M316.146 110.537C315.832 108.003 315.174 105.408 314.234 102.854L314.282 102.829L314.475 101.496C315.356 103.738 316.022 106.014 316.432 108.236C316.399 109.059 316.303 109.827 316.146 110.537Z",
    fill: "#96CBEA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.032 114.645C313.959 111.255 313.199 107.672 311.91 104.168H311.963L314.232 102.855C315.171 105.41 315.83 108.004 316.144 110.538C315.761 112.274 315.032 113.66 314.032 114.645Z",
    fill: "url(#paint77_linear_9008_207327)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M312.266 115.854C312.274 115.565 312.274 115.274 312.271 114.977C312.218 111.48 311.398 107.771 310 104.168H311.912C313.201 107.672 313.96 111.255 314.034 114.645C313.512 115.157 312.922 115.562 312.266 115.854Z",
    fill: "#89BDE0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.673 116.399C309.536 113.024 308.706 109.39 307.328 105.83L307.371 105.534L309.903 104.168H309.999C311.397 107.771 312.218 111.48 312.271 114.977C312.273 115.274 312.273 115.565 312.266 115.854C311.483 116.201 310.612 116.386 309.673 116.399Z",
    fill: "url(#paint78_linear_9008_207327)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M309.586 116.399C309.421 116.399 309.254 116.393 309.085 116.381C308.892 113.328 308.168 110.143 307.023 107.021L307.165 106.94L307.327 105.83C308.705 109.39 309.535 113.024 309.672 116.399H309.586Z",
    fill: "#96CBEA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.085 116.379C308.295 116.331 307.46 116.164 306.591 115.87C306.267 113.364 305.611 110.8 304.68 108.279H304.847L307.024 107.02C308.169 110.141 308.893 113.326 309.085 116.379Z",
    fill: "url(#paint79_linear_9008_207327)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M306.592 115.871C305.966 115.66 305.323 115.387 304.667 115.047C304.29 112.802 303.642 110.524 302.773 108.287L302.789 108.279H304.68C305.612 110.8 306.268 113.365 306.592 115.871Z",
    fill: "#89BDE0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.667 115.047C304.53 114.974 304.388 114.9 304.249 114.822C302.352 113.763 300.55 112.268 298.932 110.486L302.773 108.287C303.641 110.524 304.289 112.802 304.667 115.047Z",
    fill: "url(#paint80_linear_9008_207327)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.795 125.072C253.274 125.069 246.465 117.146 247.002 112.502C246.465 117.146 253.274 125.067 263.795 125.072Z",
    fill: "url(#paint81_linear_9008_207327)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.795 139.906L241.184 130.116L245.111 127.853C245.815 127.448 246.779 127.493 247.848 128.086C250.048 129.305 251.866 132.381 251.904 134.955C251.925 136.28 251.469 137.215 250.722 137.644L246.795 139.906Z",
    fill: "url(#paint82_linear_9008_207327)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M244.057 139.673C241.854 138.455 240.039 135.379 240.001 132.804C239.98 131.479 240.436 130.544 241.183 130.116C241.887 129.71 242.849 129.759 243.918 130.349C246.121 131.568 247.936 134.644 247.974 137.218C247.992 138.391 247.637 139.258 247.037 139.739C246.321 140.314 245.255 140.337 244.057 139.673Z",
    fill: "#4176BB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.07 99.9306L314.305 98.3318C313.363 96.2009 312.15 94.146 310.742 92.2989L311.097 92.0962C311.545 91.8377 311.973 91.5387 312.373 91.1992C314.224 93.7355 315.87 96.6773 317.07 99.9306Z",
    fill: "url(#paint83_linear_9008_207327)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.304 98.3318L312.564 97.3258C311.749 95.7726 310.835 94.26 309.832 92.8208L310.741 92.2988C312.149 94.146 313.362 96.2008 314.304 98.3318Z",
    fill: "url(#paint84_linear_9008_207327)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M312.564 97.3254L311.336 96.6159C310.67 95.4402 309.949 94.295 309.182 93.1953L309.832 92.8203C310.835 94.2595 311.749 95.7722 312.564 97.3254Z",
    fill: "#F0F9FE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.337 96.6159L307.096 94.1658C307.6 93.9909 308.109 93.7756 308.623 93.5146L308.777 93.4259L309.182 93.1953C309.949 94.295 310.671 95.4403 311.337 96.6159Z",
    fill: "url(#paint85_linear_9008_207327)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M286.02 108.604L285.579 108.488L257.251 92.1218C256.828 91.8786 256.684 91.3389 256.927 90.9157C257.17 90.4951 257.709 90.3532 258.132 90.5914L286.228 106.825L293.884 106.311L302.774 101.175L298.435 101.466L297.933 101.352L269.605 84.9816C269.184 84.7358 269.04 84.1987 269.283 83.7781C269.526 83.3549 270.063 83.2155 270.486 83.4537L298.584 99.6877L306.443 99.1607C306.866 99.1075 307.226 99.3938 307.345 99.784C307.466 100.177 307.297 100.597 306.942 100.805L294.588 107.94L294.206 108.057L286.078 108.602L286.02 108.604Z",
    fill: "#8CA2BA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.317 87.4494V87.4443C316.406 86.1749 317.196 84.8041 317.76 83.4029L317.829 83.2255C317.925 82.9747 318.014 82.7238 318.095 82.473L318.241 82.0068C318.31 81.7762 318.376 81.5482 318.434 81.3176L318.497 81.0592C319.32 77.5575 318.983 74.0735 318.485 71.5777C318.474 71.5194 318.462 71.4612 318.449 71.4029C319.287 75.4493 319.753 82.2627 315.317 87.4494ZM318.442 71.3649C318.436 71.3446 318.434 71.3243 318.429 71.3041C318.092 69.6976 317.639 68.1444 317.092 66.6571V66.652C317.644 68.1596 318.102 69.7357 318.442 71.3649ZM317.044 66.5253C315.755 63.0566 313.96 59.9426 311.949 57.2998C311.947 57.2973 311.944 57.2948 311.942 57.2922C311.934 57.2821 311.927 57.272 311.919 57.2618C311.916 57.2568 311.914 57.2542 311.909 57.2492C311.904 57.2416 311.899 57.234 311.891 57.2238C311.886 57.2188 311.881 57.2111 311.876 57.2035C311.871 57.1985 311.866 57.1909 311.861 57.1858C311.856 57.1782 311.848 57.1706 311.843 57.1605C311.838 57.1554 311.835 57.1503 311.83 57.1453C311.823 57.1351 311.815 57.1275 311.808 57.1174C311.805 57.1123 311.802 57.1073 311.8 57.1048C311.79 57.0946 311.782 57.0819 311.775 57.0718C311.772 57.0693 311.77 57.0667 311.767 57.0642C311.757 57.0515 311.749 57.0389 311.739 57.0262C311.737 57.0262 311.737 57.0236 311.737 57.0236C311.711 56.9907 311.686 56.9578 311.661 56.9274C313.788 59.6436 315.689 62.8868 317.039 66.5152C317.041 66.5177 317.041 66.5203 317.044 66.5253ZM311.625 56.8817C311.615 56.8691 311.605 56.8564 311.597 56.8463C311.607 56.8564 311.615 56.8691 311.625 56.8817ZM302.755 49.1639C302.755 49.1639 302.753 49.1638 302.753 49.1613L302.755 49.1639ZM302.69 49.1284C301.887 48.7179 301.092 48.3632 300.282 48.0617L300.274 48.0591C300.246 48.049 300.221 48.0388 300.196 48.0312C299.854 47.9046 299.512 47.8007 299.173 47.6993C298.902 47.6208 298.633 47.5448 298.362 47.4789L298.046 47.4029H298.036C297.638 47.3142 297.238 47.2356 296.818 47.1748C296.41 47.1166 296.002 47.076 295.592 47.0481L295.331 47.0329C295.066 47.0203 294.802 47.0177 294.539 47.0177C293.746 47.0279 292.959 47.0963 292.179 47.2407H292.156C293.002 47.0811 293.855 47 294.716 47C297.286 47 299.932 47.7095 302.69 49.1284Z",
    fill: "url(#paint86_linear_9008_207327)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M286.33 48.428C287.72 47.7287 291.954 45.6003 299.127 49.4593C314.038 57.4838 323.696 84.3216 311.096 92.0978L286.33 48.428Z",
    fill: "#EFF7FD"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.779 93.4264L311.096 92.0962L310.742 92.2989L309.833 92.8208L309.182 93.1958L308.779 93.4264ZM311.096 92.0962C311.775 91.706 312.385 91.1992 312.947 90.6266C313.117 90.4644 313.281 90.2972 313.438 90.1274C313.238 90.3656 313.026 90.5911 312.808 90.8039C312.666 90.9408 312.519 91.0725 312.372 91.1992C311.972 91.5387 311.545 91.8377 311.096 92.0962ZM286.133 48.5353C286.186 48.5049 286.239 48.4745 286.292 48.4466L286.133 48.5353ZM286.348 48.4163C286.601 48.2794 286.865 48.1552 287.133 48.0463C287.295 47.9804 287.457 47.9171 287.622 47.8613C287.619 47.8639 287.617 47.8639 287.614 47.8639C287.612 47.8664 287.609 47.8664 287.606 47.8689C287.601 47.8689 287.596 47.8715 287.591 47.874C287.589 47.874 287.586 47.8765 287.584 47.8765C287.579 47.8791 287.574 47.8791 287.568 47.8816C287.566 47.8842 287.563 47.8841 287.561 47.8841C287.556 47.8867 287.551 47.8892 287.546 47.8892C287.543 47.8917 287.541 47.8917 287.538 47.8943C287.533 47.8943 287.528 47.8968 287.523 47.8993C287.52 47.8993 287.518 47.9019 287.518 47.9019C287.51 47.9044 287.505 47.9069 287.5 47.9069C287.498 47.9095 287.498 47.9095 287.495 47.9095C287.49 47.912 287.485 47.9146 287.482 47.9146C287.48 47.9171 287.475 47.9171 287.472 47.9196C287.47 47.9196 287.467 47.9221 287.465 47.9221C287.46 47.9247 287.457 47.9247 287.452 47.9272C287.444 47.9297 287.437 47.9323 287.429 47.9348L287.27 47.9982C287.257 48.0032 287.244 48.0083 287.234 48.0133C286.877 48.1628 286.566 48.3073 286.348 48.4163Z",
    fill: "url(#paint87_linear_9008_207327)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M295.784 92.5042C286.005 87.011 278.379 74.1013 278.042 62.4738C277.946 59.1545 278.569 53.1038 283.812 49.8657C286.945 48.0692 291.231 48.2719 295.987 50.9045C305.783 56.3293 313.863 70.0143 314.035 81.4696C314.124 87.3657 312.098 91.5211 308.622 93.5152C303.801 95.9679 299.428 94.3792 295.784 92.5042Z",
    fill: "#B9CDE4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M279.088 52.5814C280.478 51.877 284.714 49.7309 291.903 53.6025C306.814 61.627 316.476 88.4624 303.877 96.2385L279.088 52.5814Z",
    fill: "#EFF7FD"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.561 97.569L303.878 96.2387C304.556 95.8485 305.166 95.3418 305.731 94.7666L306.053 94.4625C305.903 94.6298 305.751 94.7894 305.592 94.944C305.47 95.063 305.346 95.1771 305.217 95.2886C304.799 95.6509 304.351 95.9676 303.878 96.2387L302.612 96.9659L301.963 97.3384L301.561 97.569ZM278.914 52.6779C278.972 52.6449 279.031 52.612 279.089 52.5816C279.091 52.5791 279.094 52.5791 279.096 52.5765C279.296 52.4701 279.499 52.3688 279.707 52.2776C279.775 52.2472 279.843 52.2167 279.914 52.1889C280.076 52.123 280.238 52.0596 280.405 52.0039C280.34 52.0292 280.276 52.052 280.213 52.0774L280.043 52.1458C279.656 52.308 279.319 52.4651 279.094 52.5943L278.914 52.6779Z",
    fill: "url(#paint88_linear_9008_207327)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M288.568 96.6468C278.789 91.1535 271.16 78.2439 270.823 66.6164C270.727 63.2971 271.35 57.2464 276.596 54.0082C279.728 52.2118 284.013 52.4145 288.768 55.0471C298.564 60.4719 306.644 74.1569 306.816 85.6121C306.905 91.5083 304.879 95.6637 301.403 97.6577C296.584 100.11 292.209 98.5243 288.568 96.6468Z",
    fill: "#B9CDE4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.904 106.497L297.228 98.8398L297.165 98.8778L295.405 99.8888L293.237 101.133L284.785 105.99L283.904 106.497Z",
    fill: "url(#paint89_linear_9008_207327)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M255.936 66.0853L256.006 65.8421C257.546 65.0794 261.729 63.2349 268.641 66.957C283.489 74.946 293.129 101.591 280.77 109.497L280.519 109.433L255.936 66.0853Z",
    fill: "#EFF7FD"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.293 110.925L280.61 109.594L279.346 110.319L278.696 110.691L278.293 110.925ZM280.61 109.594L280.848 109.43C281.476 109.039 282.053 108.566 282.577 108.013C282.818 107.775 283.038 107.519 283.248 107.256C282.96 107.636 282.648 107.985 282.317 108.307C281.795 108.811 281.225 109.242 280.61 109.594ZM255.646 66.0334C255.968 65.8485 256.3 65.6863 256.644 65.5444C256.758 65.4963 256.875 65.4532 256.991 65.4102C256.943 65.4279 256.895 65.4481 256.847 65.4659C256.518 65.6002 256.226 65.7319 255.998 65.8662L255.646 66.0334Z",
    fill: "url(#paint90_linear_9008_207327)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M265.302 110.001C255.528 104.508 247.899 91.5984 247.56 79.9684C247.463 76.6491 248.084 70.601 253.33 67.3628C256.46 65.5638 260.746 65.7691 265.502 68.4017C275.298 73.8265 283.378 87.5115 283.55 98.9667C283.639 104.86 281.613 109.018 278.137 111.012C273.318 113.463 268.945 111.876 265.302 110.001Z",
    fill: "#B9CDE4"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.022 112.947C264.373 112.947 261.337 111.702 258.982 110.441C256.103 108.814 253.478 106.521 251.254 103.82L251.29 103.787C253.513 106.488 256.103 108.814 258.982 110.441C261.319 111.695 264.34 112.901 267.961 112.901C269.417 112.901 270.972 112.706 272.62 112.24C272.673 112.242 272.729 112.245 272.782 112.245C272.764 112.25 272.747 112.255 272.729 112.26C271.063 112.746 269.493 112.949 268.022 112.947ZM245.783 94.3004C245.689 94.042 245.595 93.7835 245.509 93.5251C244.613 90.8925 244.084 88.1839 243.995 85.5259C244.096 88.4423 244.777 91.4119 245.828 94.2928C245.813 94.2954 245.798 94.2979 245.783 94.3004ZM243.982 84.6898C243.993 82.379 244.355 79.6932 245.507 77.0403C246.337 75.1248 247.578 73.2244 249.388 71.4938C249.409 71.4736 249.426 71.4558 249.447 71.4355C249.416 71.4888 249.386 71.5445 249.358 71.5977C245.112 75.7151 244.003 80.7396 243.982 84.6898Z",
    fill: "url(#paint91_linear_9008_207327)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M246.236 104.941C244.099 103.757 242.337 100.775 242.301 98.2742C242.263 95.7784 243.965 94.7117 246.102 95.8949C248.239 97.0782 250.001 100.06 250.037 102.559C250.075 105.057 248.373 106.124 246.236 104.941Z",
    fill: "#ABBCCB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.317 87.4452C315.319 87.4427 315.319 87.4402 315.322 87.4376L315.438 87.2755C315.909 86.7079 316.335 86.1251 316.697 85.5272L316.796 85.3498C317.145 84.7493 317.446 84.1386 317.702 83.5179L317.76 83.4038C317.196 84.805 316.406 86.1758 315.317 87.4452ZM317.76 83.4038L317.819 83.2518L317.97 82.8262L318.095 82.4739C318.013 82.7248 317.925 82.9756 317.829 83.2265L317.76 83.4038ZM318.095 82.4739L318.208 82.1167L318.363 81.5719L318.434 81.3185C318.376 81.5491 318.31 81.7771 318.241 82.0077L318.095 82.4739ZM318.434 81.3185L318.512 80.9663C318.705 80.1302 318.831 79.2966 318.905 78.4756L318.92 78.3261C318.988 77.4925 319.006 76.6792 318.981 75.7847C318.953 74.9891 318.887 74.2265 318.791 73.4435C318.705 72.7772 318.598 72.1513 318.484 71.5787C318.983 74.0744 319.32 77.5584 318.497 81.0601L318.434 81.3185ZM318.429 71.305C318.024 69.3895 317.343 67.37 317.092 66.658C317.639 68.1454 318.092 69.6986 318.429 71.305ZM317.051 66.5466C316.385 64.7527 315.585 63.055 314.691 61.4663C313.848 59.9765 312.924 58.5829 311.949 57.3008C313.96 59.9435 315.755 63.0575 317.044 66.5263C317.046 66.5313 317.049 66.539 317.051 66.5466Z",
    fill: "url(#paint92_linear_9008_207327)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M315.304 87.4603L315.322 87.4375C315.319 87.44 315.319 87.4426 315.317 87.4451C315.314 87.4502 315.309 87.4552 315.304 87.4603Z",
    fill: "#F5FAFE"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M302.948 49.2657C302.945 49.2632 302.945 49.2632 302.943 49.2607C302.879 49.2277 302.819 49.1973 302.755 49.1644C302.821 49.1973 302.884 49.2303 302.948 49.2657Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.941 49.26C302.248 48.8951 301.564 48.5911 300.883 48.3174C300.779 48.2769 300.675 48.2338 300.571 48.1932L300.28 48.0615C301.091 48.363 301.886 48.7177 302.688 49.1282C302.693 49.1307 302.698 49.1333 302.703 49.1358C302.711 49.1409 302.716 49.1434 302.724 49.1485C302.734 49.1536 302.741 49.1561 302.752 49.1611C302.752 49.1637 302.754 49.1637 302.754 49.1637C302.817 49.1966 302.878 49.227 302.941 49.26ZM300.194 48.0311C299.974 47.9525 299.779 47.8942 299.584 47.8334C299.343 47.7549 299.105 47.6839 298.865 47.6155L298.361 47.4787C298.632 47.5446 298.9 47.6206 299.171 47.6992C299.511 47.8005 299.852 47.9044 300.194 48.0311ZM298.034 47.4027L297.888 47.3748C297.875 47.3723 297.865 47.3698 297.855 47.3672C297.634 47.3191 297.417 47.276 297.199 47.238C297.08 47.2177 296.953 47.1975 296.816 47.1747L296.502 47.1417C296.014 47.0809 295.528 47.0404 295.044 47.0277L294.538 47.0176L294.383 47.0328C293.705 47.048 293.029 47.1088 292.36 47.2254L292.18 47.2405C292.96 47.0961 293.745 47.0277 294.538 47.0176C294.801 47.0176 295.064 47.0201 295.33 47.0328L295.591 47.048C296.001 47.0758 296.409 47.1164 296.816 47.1747C297.237 47.2355 297.637 47.314 298.034 47.4027Z",
    fill: "url(#paint93_linear_9008_207327)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M292.174 47.2426C292.174 47.2426 292.177 47.2426 292.179 47.2401L292.174 47.2426Z",
    fill: "#F5FAFE"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M287.765 47.8077C288.024 47.7164 288.312 47.6278 288.624 47.5517C288.312 47.6303 288.024 47.7164 287.765 47.8077Z",
    fill: "#DCF0FC"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.812 49.8656L285.97 48.6291L286.421 48.8875C285.484 49.0801 284.613 49.4069 283.812 49.8656Z",
    fill: "url(#paint94_linear_9008_207327)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M281.691 51.6106C282.307 50.9771 282.983 50.3766 283.813 49.8648C284.613 49.4061 285.484 49.0793 286.421 48.8867L286.599 48.9906C286.469 49.0565 286.343 49.1224 286.214 49.1908C285.408 49.6595 284.684 50.2626 284.051 50.9948C283.808 51.1012 283.573 51.2204 283.345 51.3521L283.299 51.3774C282.707 51.418 282.172 51.5016 281.691 51.6106Z",
    fill: "#ABC8E4"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.299 51.3787L283.344 51.3534C283.572 51.2216 283.808 51.1025 284.051 50.9961C283.95 51.1126 283.848 51.2317 283.752 51.3559C283.598 51.361 283.446 51.3686 283.299 51.3787Z",
    fill: "url(#paint95_linear_9008_207327)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M280.404 52.0041C280.774 51.8673 281.192 51.7355 281.678 51.6241C281.683 51.619 281.691 51.6114 281.691 51.6114C282.172 51.5025 282.706 51.4188 283.298 51.3783C283.445 51.3681 283.597 51.3605 283.752 51.3555C283.714 51.4061 283.676 51.4543 283.638 51.505H283.531C282.417 51.505 281.369 51.6748 280.404 52.0041Z",
    fill: "#DCF0FC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.598 54.0073L278.914 52.677L279.094 52.5935C279.32 52.4642 279.656 52.3071 280.044 52.145L280.213 52.0765C280.277 52.0512 280.34 52.0284 280.406 52.0031C281.371 51.6737 282.419 51.5039 283.533 51.5039H283.639C283.31 51.9423 283.011 52.4186 282.74 52.9355C282.219 52.8671 281.712 52.8341 281.216 52.8341C279.499 52.8341 277.942 53.237 276.598 54.0073Z",
    fill: "url(#paint96_linear_9008_207327)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M273.295 57.118L273.333 57.0978C274.148 55.9398 275.199 54.8731 276.597 54.0091C277.941 53.2388 279.498 52.8359 281.215 52.8359C281.711 52.8359 282.218 52.8689 282.739 52.9373C282.486 53.4213 282.261 53.9407 282.066 54.4931C281.539 54.4196 281.025 54.3841 280.524 54.3841C278.883 54.3841 277.392 54.7692 276.106 55.5091L273.295 57.118Z",
    fill: "#ABC8E4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.036 85.779C281.005 77.9952 275.356 70.5687 268.641 66.9555C265.451 65.2376 262.84 64.7055 260.804 64.7055C260.531 64.7055 260.265 64.7156 260.012 64.7333L271.801 57.9732L273.295 57.1168L276.105 55.5078C277.392 54.7679 278.883 54.3828 280.524 54.3828C281.025 54.3828 281.539 54.4183 282.066 54.4918C281.443 56.2426 281.116 58.3203 281.147 60.692C281.235 67.9538 284.623 76.1607 289.632 82.4774L284.051 85.6725L284.036 85.779Z",
    fill: "url(#paint97_linear_9008_207327)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M283.782 87.1158C280.743 78.7822 274.704 70.8869 267.817 67.0736C265.103 65.571 262.546 64.8591 260.264 64.8591C259.094 64.8591 257.995 65.0466 256.99 65.4114C257.78 65.1099 258.758 64.8464 259.976 64.7552L260.011 64.7349C260.264 64.7171 260.53 64.707 260.804 64.707C262.839 64.707 265.45 65.2391 268.64 66.957C275.355 70.5702 281.004 77.9967 284.035 85.7805L283.845 87.0803L283.782 87.1158Z",
    fill: "#DCF0FC"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.528 88.4185H281.454C278.413 80.095 272.379 72.2124 265.5 68.4041C262.785 66.9016 260.225 66.1896 257.947 66.1896C256.23 66.1896 254.673 66.5925 253.328 67.3653L255.645 66.035L255.997 65.8678C256.225 65.7335 256.516 65.6017 256.845 65.4675C256.893 65.4497 256.941 65.4295 256.989 65.4117C257.995 65.0469 259.094 64.8594 260.263 64.8594C262.545 64.8594 265.102 65.5714 267.817 67.0739C274.704 70.8872 280.743 78.7825 283.781 87.1161L281.528 88.4185Z",
    fill: "url(#paint98_linear_9008_207327)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M281.454 88.4164H279.545C276.565 80.6731 270.914 73.4139 264.492 69.859C261.894 68.4198 259.441 67.7382 257.256 67.7382C255.612 67.7382 254.121 68.1233 252.832 68.8632C251.999 69.3725 251.242 69.9096 250.551 70.4671C250.553 70.4645 250.553 70.4645 250.556 70.462C250.561 70.4544 250.566 70.4468 250.571 70.4341C250.751 70.1427 251.784 68.5085 252.338 68.0726C252.652 67.8269 252.969 67.5836 253.328 67.3632C254.673 66.5904 256.23 66.1875 257.947 66.1875C260.226 66.1875 262.786 66.8995 265.5 68.402C272.38 72.2103 278.413 80.0929 281.454 88.4164Z",
    fill: "#ABC8E4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.146 91.2974C268.096 91.1859 268.045 91.0719 267.992 90.9604C265.571 85.7738 261.657 81.099 257.276 78.6741C255.281 77.5694 253.402 77.0474 251.726 77.0474C249.87 77.0474 248.265 77.6885 247.039 78.8945C247.591 75.5854 250.546 70.4773 250.546 70.4773C250.546 70.4773 250.548 70.4748 250.551 70.4672C251.242 69.9097 251.999 69.3726 252.832 68.8633C254.121 68.1234 255.613 67.7383 257.256 67.7383C259.441 67.7383 261.895 68.4199 264.493 69.8591C270.914 73.414 276.565 80.6732 279.546 88.4165H279.47L268.146 91.2974Z",
    fill: "url(#paint99_linear_9008_207327)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.807 91.7353H263.795C253.274 91.7302 246.465 83.8096 247.002 79.1652C247.01 79.0967 247.017 79.0308 247.03 78.965C247.033 78.9422 247.038 78.9168 247.04 78.894C248.266 77.6879 249.871 77.0469 251.727 77.0469C253.403 77.0469 255.282 77.5689 257.277 78.6736C261.658 81.0984 265.572 85.7733 267.993 90.9599C268.046 91.0714 268.097 91.1854 268.147 91.2969L268.145 91.2994C266.641 91.5984 265.19 91.7353 263.807 91.7353Z",
    fill: "url(#paint100_linear_9008_207327)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.86 57.187C311.855 57.1794 311.847 57.1692 311.842 57.1616C311.847 57.1718 311.855 57.1794 311.86 57.187ZM311.766 57.0653C311.756 57.0527 311.746 57.04 311.738 57.0273C311.748 57.04 311.756 57.0527 311.766 57.0653Z",
    fill: "url(#paint101_linear_9008_207327)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M311.532 56.7631C311.511 56.7378 311.489 56.7074 311.466 56.682C311.489 56.7099 311.511 56.7352 311.532 56.7631ZM311.433 56.6389C311.413 56.6136 311.395 56.5908 311.377 56.568C311.375 56.568 311.375 56.5655 311.372 56.5629C311.364 56.5528 311.357 56.5426 311.349 56.5325C311.344 56.53 311.342 56.5249 311.339 56.5199C311.332 56.5123 311.324 56.5046 311.316 56.4945C311.314 56.4894 311.309 56.4844 311.304 56.4768C311.299 56.4717 311.294 56.4641 311.286 56.4565C311.281 56.4489 311.276 56.4413 311.268 56.4337C311.263 56.4287 311.261 56.4236 311.256 56.4185C311.248 56.4084 311.24 56.4007 311.233 56.3906C311.23 56.3855 311.228 56.383 311.225 56.3805C311.215 56.3678 311.205 56.3577 311.197 56.345C311.195 56.345 311.195 56.3425 311.192 56.34C310.782 55.8383 310.364 55.3543 309.941 54.8906C310.448 55.4455 310.944 56.0283 311.433 56.6389Z",
    fill: "#ECF8FE"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.736 57.0239C311.721 57.0037 311.705 56.986 311.69 56.9682C311.69 56.9657 311.69 56.9657 311.688 56.9632C311.68 56.9505 311.67 56.9403 311.66 56.9277C311.66 56.9251 311.657 56.9251 311.657 56.9226C311.647 56.9099 311.637 56.8998 311.629 56.8871C311.627 56.8846 311.624 56.8795 311.622 56.877C311.612 56.8668 311.604 56.8567 311.597 56.8466C311.591 56.8415 311.589 56.8364 311.584 56.8288C311.579 56.8212 311.571 56.8136 311.566 56.806C311.556 56.7959 311.548 56.7832 311.538 56.7731C311.536 56.7706 311.536 56.7681 311.533 56.7655C311.48 56.6996 311.429 56.6338 311.376 56.5679C311.394 56.5907 311.412 56.6135 311.432 56.6388C311.442 56.6515 311.455 56.6667 311.465 56.6794C311.488 56.7047 311.51 56.7376 311.531 56.763C311.541 56.7731 311.548 56.7858 311.556 56.7959C311.559 56.7984 311.564 56.801 311.566 56.806C311.576 56.8187 311.584 56.8289 311.594 56.8415C311.594 56.8441 311.594 56.8441 311.597 56.8466C311.604 56.8567 311.614 56.8694 311.624 56.882C311.624 56.882 311.629 56.8846 311.629 56.8871C311.64 56.8972 311.647 56.9099 311.657 56.9226C311.657 56.9251 311.66 56.9251 311.66 56.9277C311.685 56.9581 311.71 56.991 311.736 57.0239ZM311.232 56.3905C311.229 56.388 311.227 56.3829 311.224 56.3804C311.227 56.3829 311.229 56.3854 311.232 56.3905ZM311.196 56.3449C311.194 56.3449 311.191 56.3424 311.191 56.3398C311.194 56.3424 311.194 56.3449 311.196 56.3449Z",
    fill: "url(#paint102_linear_9008_207327)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.305 67.6147C315.019 66.7355 314.682 65.8588 314.302 64.9973L317.067 66.5961L315.305 67.6147ZM314.69 61.4652C313.776 59.8461 312.76 58.3385 311.689 56.9678C311.705 56.9855 311.72 57.0032 311.735 57.0235C311.735 57.0235 311.735 57.026 311.737 57.026C311.745 57.0387 311.755 57.0514 311.765 57.064C311.768 57.0666 311.77 57.0691 311.773 57.0716C311.781 57.0818 311.788 57.0945 311.798 57.1046C311.801 57.1071 311.803 57.1122 311.806 57.1172C311.813 57.1274 311.821 57.135 311.829 57.1451C311.834 57.1502 311.836 57.1552 311.841 57.1603C311.846 57.1679 311.854 57.1781 311.859 57.1857C311.864 57.1907 311.869 57.1983 311.874 57.2034C311.879 57.211 311.884 57.2186 311.889 57.2237C311.897 57.2338 311.902 57.2414 311.907 57.249C311.912 57.2541 311.915 57.2566 311.917 57.2617C311.925 57.2718 311.932 57.2819 311.94 57.2921C311.943 57.2946 311.945 57.2971 311.948 57.2997C312.922 58.5818 313.847 59.9753 314.69 61.4652ZM311.621 56.8765C311.613 56.8664 311.603 56.8563 311.596 56.8461C311.603 56.8563 311.611 56.8664 311.621 56.8765ZM297.198 47.238C297.102 47.2228 297.009 47.2076 296.912 47.1924L296.502 47.1417L296.816 47.1747C296.953 47.1975 297.079 47.2177 297.198 47.238Z",
    fill: "url(#paint103_linear_9008_207327)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M284.051 50.9964C284.684 50.2641 285.408 49.6611 286.213 49.1924C286.342 49.124 286.469 49.0581 286.598 48.9922L288.862 50.2996C288.482 50.2616 288.11 50.2414 287.743 50.2414C286.401 50.2414 285.162 50.4998 284.051 50.9964Z",
    fill: "#C0DBEF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.085 54.2841C292.695 54.0434 292.303 53.8154 291.903 53.6026C288.712 51.8847 286.104 51.3526 284.068 51.3526C283.962 51.3526 283.856 51.3525 283.752 51.3551C283.848 51.2309 283.949 51.1118 284.051 50.9953C285.162 50.4987 286.4 50.2402 287.742 50.2402C288.11 50.2402 288.482 50.2605 288.862 50.2985L293.89 53.2048C293.594 53.5265 293.326 53.8863 293.085 54.2841Z",
    fill: "url(#paint104_linear_9008_207327)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M292.813 54.7696C292.243 54.3921 291.666 54.0399 291.083 53.7156C288.412 52.2384 285.89 51.5239 283.637 51.5036C283.675 51.4529 283.713 51.4048 283.751 51.3541C283.854 51.3515 283.961 51.3516 284.067 51.3516C286.103 51.3516 288.711 51.8837 291.901 53.6016C292.301 53.8144 292.694 54.0424 293.084 54.2831C292.99 54.4377 292.899 54.6024 292.813 54.7696Z",
    fill: "#E1F4FD"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.983 57.1644C290.94 56.3662 289.863 55.6542 288.767 55.0461C286.643 53.8704 284.615 53.1787 282.738 52.9355C283.009 52.4186 283.308 51.9423 283.637 51.5039C285.891 51.5242 288.413 52.2387 291.084 53.7159C291.666 54.0402 292.244 54.3924 292.813 54.77C292.451 55.4718 292.173 56.2725 291.983 57.1644Z",
    fill: "url(#paint105_linear_9008_207327)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M291.724 59.2365C290.45 58.1799 289.123 57.2602 287.761 56.5051C285.758 55.3953 283.839 54.7365 282.066 54.4932C282.261 53.9409 282.487 53.4215 282.74 52.9375C284.616 53.1807 286.644 53.8724 288.769 55.0481C289.865 55.6562 290.941 56.3682 291.984 57.1664C291.85 57.8099 291.762 58.5017 291.724 59.2365Z",
    fill: "#C0DBEF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.631 82.4778C284.623 76.1611 281.235 67.9542 281.146 60.6924C281.116 58.3208 281.443 56.243 282.066 54.4922C283.838 54.7354 285.757 55.3942 287.76 56.504C289.122 57.2591 290.449 58.1788 291.723 59.2354C291.708 59.5623 291.7 59.8993 291.705 60.2439C291.774 65.9677 294.726 72.5201 298.932 77.1518L289.631 82.4778Z",
    fill: "url(#paint106_linear_9008_207327)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.474 68.1622C313.922 66.7534 313.281 65.3573 312.564 63.9941L314.304 64.9975C314.684 65.859 315.021 66.7357 315.307 67.6149L314.486 68.0887L314.474 68.1622Z",
    fill: "url(#paint107_linear_9008_207327)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M314.233 69.522C313.45 67.3911 312.473 65.2931 311.336 63.2812L312.564 63.9933C313.281 65.3564 313.921 66.7526 314.473 68.1613L314.281 69.4941L314.233 69.522Z",
    fill: "#E5F5FD"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.963 70.8338H311.91C310.55 67.1446 308.608 63.5467 306.264 60.3516L311.335 63.2806C312.472 65.2924 313.45 67.3904 314.232 69.5213L311.963 70.8338Z",
    fill: "url(#paint108_linear_9008_207327)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M311.911 70.8357H309.999C308.138 66.0316 305.252 61.4201 301.793 57.7715L306.265 60.3534C308.609 63.5485 310.551 67.1465 311.911 70.8357Z",
    fill: "#CDE5F5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.329 72.4948C304.48 65.1493 299.297 58.1079 293.086 54.2845C293.326 53.8867 293.595 53.5269 293.891 53.2051L301.794 57.771C305.252 61.4196 308.139 66.0311 310 70.8351H309.904L307.372 72.1983L307.329 72.4948Z",
    fill: "url(#paint109_linear_9008_207327)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M307.024 73.6889C304.234 66.0875 298.952 58.8586 292.814 54.7716C292.901 54.6044 292.992 54.4397 293.085 54.2852C299.297 58.1086 304.48 65.15 307.328 72.4955L307.166 73.6078L307.024 73.6889Z",
    fill: "#E5F5FD"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.847 74.9455H304.68C302.113 67.9928 297.464 61.3593 291.984 57.1659C292.174 56.274 292.453 55.4733 292.815 54.7715C298.953 58.8585 304.234 66.0874 307.025 73.6887L304.847 74.9455Z",
    fill: "url(#paint110_linear_9008_207327)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M302.773 74.9558C300.418 68.8924 296.43 63.1382 291.723 59.2361C291.761 58.5013 291.849 57.8096 291.983 57.166C297.463 61.3594 302.112 67.9929 304.679 74.9456H302.788L302.773 74.9558Z",
    fill: "#CDE5F5"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.931 77.1508C294.725 72.519 291.773 65.9667 291.705 60.2428C291.7 59.8983 291.707 59.5612 291.722 59.2344C296.429 63.1364 300.417 68.8907 302.772 74.954L298.931 77.1508Z",
    fill: "url(#paint111_linear_9008_207327)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.137 111.014C278.187 110.983 278.241 110.953 278.291 110.922L278.294 110.924L278.137 111.014Z",
    fill: "url(#paint112_linear_9008_207327)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M241.37 103.661C240.548 102.362 240.021 100.844 240.001 99.4706C239.98 98.1454 240.436 97.2104 241.183 96.7822L241.368 96.6758L241.37 103.661Z",
    fill: "#144A90"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M245.512 106.814C245.063 106.776 244.575 106.624 244.058 106.338C243.033 105.77 242.088 104.797 241.372 103.66L241.369 96.6739L245.112 94.5176C245.236 94.4467 245.37 94.396 245.512 94.3555V94.4771L243.45 95.6654C242.726 96.081 242.283 96.9881 242.303 98.2727C242.336 100.482 243.716 103.069 245.512 104.458V106.814Z",
    fill: "#144A90"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 106.825C245.664 106.825 245.588 106.823 245.512 106.815V104.459C245.747 104.641 245.99 104.803 246.238 104.94C246.831 105.267 247.388 105.424 247.887 105.424C248.262 105.424 248.601 105.335 248.895 105.168L249.252 104.96C249.097 105.11 248.948 105.262 248.803 105.417L246.795 106.572C246.481 106.737 246.127 106.825 245.737 106.825ZM245.512 94.4782V94.3565C245.6 94.3337 245.691 94.3135 245.785 94.3008C245.788 94.3058 245.79 94.3109 245.79 94.316L245.512 94.4782Z",
    fill: "#345DAB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.803 105.416C248.947 105.261 249.096 105.109 249.251 104.96L249.385 104.881C249.378 104.899 249.367 104.914 249.36 104.929C249.228 105.059 249.099 105.188 248.972 105.317L248.803 105.416Z",
    fill: "url(#paint113_linear_9008_207327)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.061 104.688C250.116 104.584 250.169 104.49 250.218 104.401L251.246 103.809L251.256 103.819L250.721 104.308L250.061 104.688Z",
    fill: "url(#paint114_linear_9008_207327)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.434 97.6405C301.474 97.6175 301.517 97.5919 301.558 97.5664L301.56 97.569L301.434 97.6405Z",
    fill: "url(#paint115_linear_9008_207327)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M317.092 66.6516C317.075 66.606 317.057 66.5604 317.039 66.5148C317.009 66.4312 316.996 66.3906 316.996 66.3906C316.996 66.3906 317.032 66.4844 317.092 66.6516Z",
    fill: "#9BCEE9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.973 105.317C249.099 105.188 249.228 105.059 249.36 104.929C249.368 104.914 249.378 104.899 249.385 104.881L250.218 104.402C250.17 104.491 250.117 104.585 250.061 104.689L248.973 105.317Z",
    fill: "url(#paint116_linear_9008_207327)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.621 93.5157C308.672 93.4851 308.725 93.4545 308.776 93.4238L308.778 93.4264L308.621 93.5157Z",
    fill: "url(#paint117_linear_9008_207327)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.447 71.4033C318.44 71.3704 318.435 71.3374 318.427 71.3045C318.432 71.3247 318.435 71.345 318.44 71.3653C318.442 71.378 318.445 71.3906 318.447 71.4033ZM317.09 66.6575C317.075 66.6144 317.057 66.5688 317.042 66.5258C317.04 66.5207 317.04 66.5182 317.037 66.5156C317.055 66.5612 317.073 66.6068 317.09 66.6525V66.6575Z",
    fill: "url(#paint118_linear_9008_207327)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M313.438 90.1266C313.83 89.6604 314.19 89.1435 314.509 88.581C314.666 88.4137 314.817 88.244 314.964 88.0742C314.514 88.8293 314.01 89.5083 313.438 90.1266Z",
    fill: "#90C7E9"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.778 93.4266L308.775 93.4241C309.687 92.8794 310.495 92.18 311.186 91.3388C312.508 90.4976 313.596 89.5651 314.508 88.582C314.189 89.1445 313.829 89.6614 313.437 90.1276C313.28 90.2974 313.115 90.4647 312.946 90.6268C312.384 91.1994 311.773 91.7062 311.095 92.0964L308.778 93.4266Z",
    fill: "url(#paint119_linear_9008_207327)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M306.131 94.4159C306.516 94.0105 306.865 93.5822 307.184 93.1262L307.258 93.0831C307.518 92.9336 307.772 92.7689 308.015 92.589C309.028 92.4066 309.969 92.0645 310.82 91.5679C310.944 91.4919 311.068 91.4159 311.187 91.3398C310.496 92.1811 309.688 92.8804 308.777 93.4252C308.726 93.4556 308.673 93.486 308.622 93.5164C307.774 93.9471 306.949 94.2157 306.131 94.4159Z",
    fill: "#70A7D1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.184 93.125C307.29 92.9755 307.391 92.821 307.49 92.6664C307.667 92.6436 307.842 92.6183 308.014 92.5879C307.771 92.7678 307.518 92.9325 307.257 93.082L307.184 93.125Z",
    fill: "url(#paint120_linear_9008_207327)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M306.053 94.4625C306.521 93.9354 306.944 93.3426 307.316 92.6863C307.374 92.6787 307.433 92.6736 307.491 92.666C307.392 92.8206 307.291 92.9751 307.185 93.1246C306.866 93.5807 306.516 94.0089 306.131 94.4143C306.119 94.4169 306.106 94.4219 306.096 94.4245L306.053 94.4625Z",
    fill: "#90C7E9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.559 97.5701L301.557 97.5676C303.327 96.5059 304.709 94.8716 305.61 92.723C305.828 92.7356 306.043 92.7407 306.254 92.7407C306.616 92.7407 306.968 92.723 307.315 92.6875C306.942 93.3438 306.519 93.9366 306.051 94.4637L305.729 94.7677C305.165 95.3429 304.555 95.8496 303.876 96.2398L301.559 97.5701Z",
    fill: "url(#paint121_linear_9008_207327)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M297.227 98.8423L300.017 97.2384C301.726 96.2578 303.073 94.6565 303.944 92.5078C304.514 92.6193 305.071 92.6902 305.61 92.7232C304.709 94.8718 303.326 96.5061 301.556 97.5678C301.516 97.5931 301.473 97.6185 301.432 97.6413L301.402 97.659C299.966 98.3887 298.576 98.7308 297.227 98.8423Z",
    fill: "#70A7D1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.904 106.499C287.467 101.441 287.019 93.4372 284.036 85.7801L284.051 85.6736L289.632 82.4785C292.301 85.8408 295.428 88.6686 298.762 90.5284C300.573 91.5368 302.312 92.188 303.946 92.5073C303.074 94.6559 301.727 96.2572 300.018 97.2378L297.228 98.8417L283.904 106.499Z",
    fill: "url(#paint122_linear_9008_207327)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M283.248 107.256C284.962 105.011 285.927 101.747 285.866 97.6374C285.816 94.2345 285.066 90.6365 283.782 87.1146L283.846 87.0791L284.036 85.7793C287.018 93.4364 287.466 101.441 283.904 106.498L283.754 106.584C283.59 106.812 283.423 107.038 283.248 107.256Z",
    fill: "#90C7E9"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.294 110.925L278.291 110.923C281.674 108.896 283.636 104.776 283.55 98.9683C283.499 95.5553 282.747 91.9471 281.456 88.4176H281.53L283.783 87.1152C285.067 90.6372 285.816 94.2352 285.867 97.638C285.928 101.748 284.963 105.011 283.249 107.256C283.039 107.52 282.818 107.776 282.578 108.014C282.054 108.566 281.476 109.04 280.848 109.43L280.61 109.595L278.294 110.925Z",
    fill: "url(#paint123_linear_9008_207327)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M273.064 112.248C272.97 112.248 272.876 112.248 272.783 112.246C274.001 111.889 275.269 111.379 276.586 110.688C279.928 108.77 281.868 104.789 281.784 99.1412C281.731 95.6749 280.923 91.9933 279.546 88.4182H281.455C282.746 91.9477 283.498 95.5558 283.549 98.9689C283.635 104.776 281.673 108.896 278.29 110.923C278.239 110.954 278.186 110.984 278.135 111.015C276.381 111.906 274.687 112.248 273.064 112.248ZM249.447 71.4367C250.141 70.2129 251.08 69.0601 252.331 68.082C251.777 68.5254 250.754 70.1445 250.574 70.4359C250.569 70.4486 250.561 70.4562 250.556 70.4638C250.554 70.4663 250.554 70.4663 250.551 70.4688C250.161 70.7855 249.794 71.1099 249.447 71.4367Z",
    fill: "#70A7D1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.961 112.902C264.34 112.902 261.319 111.696 258.982 110.442C256.103 108.815 253.513 106.489 251.29 103.788L251.254 103.821L251.244 103.811L251.373 103.735C253.265 105.99 255.435 107.88 257.729 109.152C259.724 110.254 261.603 110.776 263.279 110.776C267.652 110.776 270.625 107.214 270.534 101.13C270.531 100.844 270.518 100.56 270.503 100.271C270.326 97.3396 269.478 94.2433 268.146 91.299L279.469 88.4181H279.545C280.923 91.9933 281.73 95.6749 281.783 99.1411C281.867 104.789 279.927 108.769 276.585 110.688C275.268 111.379 274 111.889 272.782 112.246C272.729 112.246 272.673 112.243 272.62 112.241C270.972 112.707 269.417 112.902 267.961 112.902ZM245.788 94.3167C245.788 94.3117 245.785 94.3066 245.783 94.3016C245.798 94.299 245.813 94.2965 245.828 94.2939C244.777 91.413 244.096 88.4434 243.995 85.5271C243.993 85.4054 243.99 85.2863 243.987 85.1647C243.985 85.0102 243.982 84.8505 243.982 84.6909C244.003 80.7407 245.112 75.7163 249.358 71.5989C249.386 71.5456 249.416 71.4899 249.447 71.4367C249.793 71.1098 250.161 70.7855 250.551 70.4688C250.548 70.4764 250.546 70.4789 250.546 70.4789C250.546 70.4789 247.591 75.587 247.039 78.8961C245.38 80.5304 244.418 83.196 244.471 86.6977C244.507 89.1352 245.031 91.7095 245.932 94.2332L245.788 94.3167Z",
    fill: "url(#paint124_linear_9008_207327)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.281 110.775C261.605 110.775 259.726 110.253 257.731 109.15C255.437 107.879 253.267 105.988 251.375 103.733L256.016 101.055C256.741 100.639 257.184 99.7324 257.163 98.4478C257.125 95.9495 255.363 92.9646 253.229 91.7814C252.636 91.4545 252.077 91.2999 251.58 91.2999C251.206 91.2999 250.866 91.3861 250.573 91.5559L245.934 94.2316C245.032 91.7079 244.508 89.1336 244.473 86.6961C244.42 83.1944 245.382 80.5288 247.04 78.8945C247.038 78.9173 247.033 78.9427 247.03 78.9655C247.018 79.0314 247.01 79.0973 247.002 79.1657C246.466 83.8101 253.274 91.7332 263.795 91.7358H263.808C265.193 91.7358 266.641 91.5989 268.145 91.2999L268.148 91.2974C269.479 94.2417 270.328 97.338 270.505 100.27C270.52 100.558 270.533 100.842 270.535 101.129C270.626 107.212 267.654 110.775 263.281 110.775Z",
    fill: "url(#paint125_linear_9008_207327)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.893 105.168C249.617 104.75 250.058 103.846 250.038 102.558C250.002 100.06 248.24 97.0778 246.103 95.8945C245.51 95.5652 244.953 95.4106 244.454 95.4106C244.082 95.4106 243.74 95.4993 243.449 95.6665L245.51 94.4782L245.789 94.316L245.933 94.2324L250.572 91.5567C250.866 91.387 251.205 91.3008 251.58 91.3008C252.076 91.3008 252.636 91.4553 253.228 91.7822C255.363 92.9655 257.125 95.9503 257.163 98.4486C257.183 99.7333 256.74 100.64 256.016 101.056L251.375 103.734L251.245 103.81L250.217 104.403L249.384 104.882L249.25 104.96L248.893 105.168Z",
    fill: "url(#paint126_linear_9008_207327)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M247.885 105.424C247.386 105.424 246.829 105.267 246.236 104.94C245.988 104.803 245.745 104.641 245.51 104.458C243.714 103.07 242.334 100.483 242.301 98.2733C242.281 96.9887 242.724 96.0816 243.448 95.6661C243.74 95.4988 244.081 95.4102 244.454 95.4102C244.953 95.4102 245.51 95.5647 246.102 95.8941C248.239 97.0774 250.001 100.06 250.037 102.558C250.057 103.845 249.617 104.75 248.892 105.168C248.599 105.335 248.259 105.424 247.885 105.424Z",
    fill: "#6898BA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.322 87.4367C317.039 83.9959 317.294 79.5617 316.431 74.9021C316.444 74.6208 316.446 74.332 316.444 74.0381C316.418 71.9629 316.013 69.7763 315.307 67.6149L317.069 66.5963C317.064 66.5786 317.056 66.5609 317.051 66.5457C317.049 66.5381 317.046 66.5305 317.044 66.5254C317.059 66.5685 317.077 66.6141 317.092 66.6572C317.342 67.3691 318.024 69.3886 318.429 71.3041C318.436 71.3371 318.441 71.37 318.449 71.4029C318.462 71.4612 318.474 71.5195 318.484 71.5778C318.598 72.1504 318.705 72.7763 318.791 73.4427C318.887 74.2256 318.953 74.9883 318.981 75.7839C319.006 76.6783 318.988 77.4916 318.92 78.3253L318.905 78.4747C318.831 79.2957 318.705 80.1293 318.512 80.9654L318.434 81.3177L318.363 81.571L318.208 82.1158L318.094 82.4731L317.97 82.8253L317.818 83.2509L317.76 83.403L317.702 83.517C317.446 84.1378 317.145 84.7484 316.795 85.3489L316.697 85.5263C316.335 86.1242 315.909 86.707 315.438 87.2746L315.322 87.4367Z",
    fill: "url(#paint127_linear_9008_207327)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M314.508 88.5823C315.733 86.4285 316.402 83.5806 316.351 80.1397C316.336 79.1743 316.268 78.1937 316.144 77.203C316.301 76.4936 316.397 75.7258 316.43 74.9023C317.293 79.562 317.037 83.9961 315.321 87.437L315.303 87.4598L314.964 88.073C314.817 88.2428 314.665 88.415 314.508 88.5823Z",
    fill: "#94C9E9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.188 91.3391C313.069 89.0562 314.099 85.7141 314.036 81.47C314.034 81.4168 314.034 81.3636 314.034 81.3129C315.034 80.3248 315.763 78.9388 316.145 77.2031C316.269 78.1938 316.338 79.1744 316.353 80.1398C316.404 83.5807 315.735 86.4286 314.51 88.5824C313.598 89.5655 312.509 90.4979 311.188 91.3391Z",
    fill: "url(#paint128_linear_9008_207327)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M308.014 92.5878C310.571 90.7002 312.156 87.239 312.265 82.5186C312.921 82.2297 313.511 81.8243 314.032 81.3125C314.032 81.3632 314.032 81.4164 314.035 81.4696C314.098 85.7137 313.068 89.0557 311.186 91.3387C311.067 91.4147 310.943 91.4907 310.819 91.5667C309.968 92.0633 309.026 92.4054 308.014 92.5878Z",
    fill: "#80B5DB"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.49 92.6673C309.151 90.0423 309.817 86.7028 309.673 83.0643C310.612 83.0542 311.483 82.8692 312.266 82.5195C312.157 87.24 310.572 90.7011 308.014 92.5888C307.842 92.6192 307.667 92.6445 307.49 92.6673Z",
    fill: "url(#paint129_linear_9008_207327)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M307.314 92.6854C308.525 90.5342 309.183 87.7014 309.132 84.2808C309.127 83.8729 309.11 83.4599 309.084 83.0469C309.254 83.057 309.421 83.0621 309.583 83.0621H309.672C309.816 86.7006 309.15 90.0401 307.489 92.6651C307.431 92.6727 307.373 92.6778 307.314 92.6854Z",
    fill: "#94C9E9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.254 92.7401C306.044 92.7401 305.829 92.735 305.611 92.7223C306.434 90.7637 306.857 88.3794 306.817 85.6125C306.801 84.6041 306.725 83.5754 306.591 82.5391C307.46 82.8304 308.295 82.9977 309.085 83.0484C309.111 83.4614 309.128 83.8744 309.133 84.2823C309.184 87.7029 308.526 90.5357 307.315 92.6869C306.969 92.7224 306.617 92.7401 306.254 92.7401Z",
    fill: "url(#paint130_linear_9008_207327)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M305.611 92.7222C305.072 92.6893 304.515 92.6183 303.945 92.5068C304.695 90.6572 305.09 88.3996 305.052 85.7847C305.032 84.4519 304.9 83.0913 304.667 81.7129C305.323 82.055 305.966 82.3286 306.591 82.5389C306.726 83.5752 306.801 84.6039 306.817 85.6124C306.857 88.3793 306.434 90.7636 305.611 92.7222Z",
    fill: "#80B5DB"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.945 92.5071C302.311 92.1879 300.572 91.5367 298.761 90.5282C295.427 88.6684 292.3 85.8407 289.631 82.4784L298.931 77.1523C300.549 78.9336 302.352 80.4311 304.248 81.4877C304.388 81.5662 304.529 81.6422 304.666 81.7132C304.899 83.0915 305.031 84.4522 305.051 85.785C305.089 88.3999 304.694 90.6575 303.945 92.5071Z",
    fill: "url(#paint131_linear_9008_207327)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.43 74.9024C316.02 72.6803 315.354 70.4049 314.473 68.1625L314.485 68.089L315.306 67.6152C316.012 69.7766 316.417 71.9632 316.443 74.0384C316.445 74.3323 316.443 74.6211 316.43 74.9024Z",
    fill: "url(#paint132_linear_9008_207327)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M316.146 77.2026C315.832 74.6714 315.174 72.0743 314.234 69.5228L314.282 69.4949L314.475 68.1621C315.356 70.4045 316.022 72.6798 316.432 74.902C316.399 75.7254 316.303 76.4932 316.146 77.2026Z",
    fill: "#96CBEA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.032 81.3131C313.959 77.9204 313.199 74.3376 311.91 70.8359H311.963L314.232 69.5234C315.171 72.075 315.83 74.6721 316.144 77.2033C315.761 78.939 315.032 80.325 314.032 81.3131Z",
    fill: "url(#paint133_linear_9008_207327)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M312.266 82.5192C312.274 82.2329 312.274 81.939 312.271 81.6425C312.218 78.1484 311.398 74.439 310 70.8359H311.912C313.201 74.3376 313.96 77.9204 314.034 81.3132C313.512 81.825 312.922 82.2304 312.266 82.5192Z",
    fill: "#89BDE0"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.673 83.064C309.536 79.689 308.706 76.0555 307.328 72.4956L307.371 72.1991L309.903 70.8359H309.999C311.397 74.439 312.218 78.1484 312.271 81.6425C312.273 81.939 312.273 82.2329 312.266 82.5192C311.483 82.8689 310.612 83.0539 309.673 83.064Z",
    fill: "url(#paint134_linear_9008_207327)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M309.583 83.0645C309.421 83.0645 309.254 83.0595 309.085 83.0493C308.892 79.9936 308.168 76.8086 307.023 73.6895L307.165 73.6085L307.327 72.4961C308.705 76.0561 309.535 79.6895 309.672 83.0645H309.583Z",
    fill: "#96CBEA"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.085 83.0473C308.295 82.9966 307.46 82.8294 306.591 82.538C306.267 80.0321 305.611 77.4679 304.68 74.9443H304.847L307.024 73.6875C308.169 76.8066 308.893 79.9916 309.085 83.0473Z",
    fill: "url(#paint135_linear_9008_207327)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M306.592 82.5391C305.966 82.3287 305.323 82.0551 304.667 81.713C304.29 79.4706 303.642 77.1902 302.773 74.9554L302.789 74.9453H304.68C305.612 77.469 306.268 80.0331 306.592 82.5391Z",
    fill: "#89BDE0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.667 81.7127C304.53 81.6417 304.388 81.5657 304.249 81.4872C302.352 80.4306 300.55 78.9331 298.932 77.1518L302.773 74.9551C303.641 77.1899 304.289 79.4703 304.667 81.7127Z",
    fill: "url(#paint136_linear_9008_207327)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M250.572 70.4357C250.752 70.1443 251.777 68.5252 252.332 68.0818C252.334 68.0793 252.337 68.0768 252.339 68.0742C251.785 68.51 250.752 70.1443 250.572 70.4357Z",
    fill: "#68A3D2"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.795 91.7358C253.274 91.7332 246.465 83.8101 247.002 79.1657C246.465 83.8101 253.274 91.7307 263.795 91.7358Z",
    fill: "url(#paint137_linear_9008_207327)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.795 106.572L241.184 96.7818L245.111 94.5191C245.815 94.1163 246.779 94.1619 247.848 94.7522C250.048 95.971 251.866 99.047 251.904 101.621C251.925 102.947 251.469 103.881 250.722 104.31L246.795 106.572Z",
    fill: "url(#paint138_linear_9008_207327)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M244.057 106.338C241.854 105.12 240.039 102.044 240.001 99.4692C239.98 98.144 240.436 97.2091 241.183 96.7809C241.887 96.378 242.849 96.4236 243.918 97.014C246.121 98.2352 247.936 101.309 247.974 103.886C247.992 105.059 247.637 105.925 247.037 106.404C246.321 106.979 245.255 107.002 244.057 106.338Z",
    fill: "#4176BB"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M309.942 54.8898C308.24 53.025 306.455 51.487 304.741 50.3366C304.738 50.3366 304.738 50.3341 304.736 50.3341C304.726 50.3265 304.715 50.3189 304.705 50.3138C304.7 50.3113 304.695 50.3062 304.69 50.3037C304.678 50.2935 304.662 50.2834 304.647 50.2758L304.602 50.2454C304.591 50.2378 304.579 50.2302 304.569 50.2226C304.564 50.2201 304.559 50.215 304.553 50.2125C304.538 50.2049 304.526 50.1947 304.513 50.1871C304.508 50.1846 304.505 50.1821 304.5 50.1795C304.467 50.1567 304.434 50.1364 304.402 50.1162C304.402 50.1136 304.399 50.1136 304.399 50.1136C303.958 49.8299 303.523 49.5714 303.095 49.3408C303.082 49.3358 303.07 49.3282 303.057 49.3231C303.049 49.318 303.039 49.3129 303.029 49.3079C303.027 49.3053 303.027 49.3054 303.024 49.3054C302.999 49.2902 302.973 49.2775 302.948 49.2648C302.996 49.2902 303.047 49.3155 303.095 49.3408C305.288 50.5216 307.686 52.4168 309.942 54.8898ZM286.292 48.4464L286.33 48.4261C286.335 48.4211 286.34 48.4185 286.348 48.416C286.343 48.4185 286.34 48.4211 286.335 48.4211C286.335 48.4236 286.333 48.4236 286.33 48.4261C286.318 48.4312 286.305 48.4388 286.292 48.4464Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.281 48.0617C300.269 48.0566 300.254 48.0515 300.241 48.0464C300.226 48.0414 300.211 48.0363 300.195 48.0312C300.221 48.0389 300.246 48.049 300.274 48.0591L300.281 48.0617Z",
    fill: "url(#paint139_linear_9008_207327)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M288.624 47.5521C288.624 47.5521 288.624 47.5495 288.627 47.5495C288.624 47.5495 288.624 47.5495 288.624 47.5521ZM288.665 47.5394C289.417 47.3544 290.323 47.2227 291.399 47.2227C291.556 47.2227 291.716 47.2252 291.883 47.2328C291.858 47.2353 291.835 47.2404 291.812 47.2429C291.632 47.2378 291.46 47.2328 291.288 47.2328C290.27 47.2328 289.396 47.3595 288.665 47.5394Z",
    fill: "#F5FBFE"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.133 48.5347L286.292 48.446C286.305 48.4384 286.318 48.4308 286.33 48.4258C286.333 48.4232 286.335 48.4233 286.335 48.4207C286.34 48.4207 286.343 48.4182 286.348 48.4157C286.566 48.3067 286.877 48.1622 287.234 48.0128C286.87 48.1673 286.551 48.3143 286.338 48.4384L286.133 48.5347Z",
    fill: "url(#paint140_linear_9008_207327)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.069 66.5957C316.401 64.7841 315.593 63.0687 314.691 61.4648C315.585 63.0535 316.385 64.7512 317.051 66.5451C317.056 66.5603 317.064 66.578 317.069 66.5957Z",
    fill: "url(#paint141_linear_9008_207327)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M303.024 49.3057C302.997 49.2904 302.971 49.2751 302.943 49.2598C302.946 49.2623 302.946 49.2623 302.948 49.2649C302.974 49.2776 302.999 49.2904 303.024 49.3057Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.095 49.3415C302.348 48.9411 301.614 48.6118 300.884 48.3178C301.565 48.5915 302.249 48.8955 302.943 49.2604C302.971 49.2756 302.996 49.2908 303.024 49.306C303.026 49.306 303.026 49.306 303.029 49.3085C303.039 49.3136 303.049 49.3187 303.057 49.3238C303.069 49.3288 303.082 49.3364 303.095 49.3415ZM300.573 48.1937L300.241 48.0467L299.585 47.8339C299.78 47.8947 299.975 47.953 300.196 48.0315C300.211 48.0366 300.226 48.0416 300.241 48.0467C300.254 48.0518 300.269 48.0569 300.282 48.0619L300.573 48.1937ZM297.856 47.3677C297.646 47.3221 297.436 47.2815 297.2 47.2384C297.418 47.2764 297.636 47.3195 297.856 47.3677Z",
    fill: "url(#paint142_linear_9008_207327)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M291.833 47.2472C291.825 47.2472 291.818 47.2471 291.812 47.2446C291.835 47.242 291.858 47.2369 291.883 47.2344L292.175 47.2446L291.833 47.2472Z",
    fill: "#F9FDFF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M287.621 47.8628C287.624 47.8628 287.626 47.8628 287.626 47.8602C287.629 47.8602 287.631 47.8602 287.634 47.8577C287.639 47.8552 287.644 47.8552 287.649 47.8526C287.651 47.8526 287.654 47.8501 287.657 47.8501C287.662 47.8476 287.667 47.845 287.674 47.845C287.674 47.8425 287.677 47.8425 287.677 47.8425C287.684 47.84 287.689 47.8374 287.697 47.8349C287.705 47.8323 287.712 47.8298 287.72 47.8273C287.727 47.8248 287.735 47.8222 287.743 47.8197C287.75 47.8172 287.758 47.8121 287.765 47.8096C288.024 47.7183 288.312 47.6322 288.624 47.5536C288.624 47.5511 288.624 47.5511 288.626 47.5511C288.631 47.5511 288.639 47.5486 288.644 47.546C288.649 47.546 288.654 47.5461 288.659 47.5435C288.659 47.5435 288.662 47.5435 288.664 47.541C289.396 47.3611 290.27 47.2344 291.288 47.2344C291.46 47.2344 291.632 47.2394 291.812 47.2445C291.591 47.2825 291.374 47.3231 291.156 47.3687C291.019 47.3662 290.885 47.3636 290.751 47.3636C289.637 47.3636 288.588 47.5334 287.621 47.8628Z",
    fill: "#EAF7FE"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.421 48.8886L285.971 48.6302L286.133 48.5364L286.338 48.4401C286.551 48.316 286.87 48.169 287.234 48.0144C287.244 48.0094 287.257 48.0043 287.27 47.9992L287.429 47.9359C287.437 47.9334 287.444 47.9308 287.452 47.9283C287.457 47.9258 287.46 47.9258 287.465 47.9232L287.472 47.9207L287.482 47.9157C287.482 47.9157 287.49 47.9131 287.495 47.9105L287.5 47.908C287.505 47.908 287.51 47.9055 287.518 47.903L287.523 47.9004C287.528 47.8979 287.533 47.8954 287.538 47.8954L287.546 47.8903C287.551 47.8903 287.556 47.8878 287.561 47.8852L287.568 47.8827C287.573 47.8802 287.579 47.8801 287.584 47.8776L287.591 47.8751C287.596 47.8726 287.601 47.87 287.606 47.87L287.614 47.865L287.622 47.8624C288.589 47.533 289.637 47.3633 290.751 47.3633C290.885 47.3633 291.02 47.3658 291.156 47.3683C289.769 47.6597 288.386 48.131 287.014 48.7873C286.814 48.8151 286.616 48.8506 286.421 48.8886Z",
    fill: "url(#paint143_linear_9008_207327)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M286.597 48.9904L286.42 48.8865C286.615 48.8485 286.812 48.813 287.012 48.7852C286.873 48.8536 286.736 48.9194 286.597 48.9904Z",
    fill: "#CBE5F5"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M311.286 56.455C311.281 56.4474 311.275 56.4424 311.268 56.4322C311.275 56.4398 311.281 56.4474 311.286 56.455ZM311.255 56.417C311.248 56.4094 311.24 56.3993 311.232 56.3891C311.24 56.3993 311.248 56.4069 311.255 56.417ZM311.192 56.3385C309.128 53.8123 306.88 51.7726 304.74 50.3359C306.454 51.4863 308.24 53.0243 309.941 54.8891C310.364 55.3528 310.782 55.8368 311.192 56.3385Z",
    fill: "#F4FBFE"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.534 56.7642C309.376 54.0403 306.999 51.8511 304.74 50.3359C306.88 51.7726 309.128 53.8123 311.192 56.3385C311.192 56.341 311.194 56.3435 311.197 56.3435C311.205 56.3562 311.215 56.3663 311.225 56.379C311.227 56.3815 311.23 56.3866 311.232 56.3891C311.24 56.3993 311.248 56.4094 311.255 56.417C311.26 56.4221 311.263 56.4272 311.268 56.4322C311.275 56.4424 311.281 56.4474 311.286 56.455C311.293 56.4626 311.298 56.4702 311.303 56.4753C311.308 56.4829 311.313 56.488 311.316 56.493C311.324 56.5032 311.331 56.5108 311.339 56.5184C311.341 56.5234 311.344 56.5285 311.349 56.531C311.356 56.5412 311.364 56.5513 311.372 56.5615C311.374 56.564 311.374 56.5665 311.377 56.5665C311.43 56.6324 311.481 56.6983 311.534 56.7642Z",
    fill: "url(#paint144_linear_9008_207327)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M304.69 50.3052C304.674 50.2951 304.662 50.2875 304.646 50.2773C304.662 50.2849 304.677 50.2951 304.69 50.3052Z",
    fill: "#F4FBFE"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M304.569 50.2239C304.564 50.2211 304.558 50.2184 304.553 50.2129C304.558 50.2156 304.564 50.2211 304.569 50.2239Z",
    fill: "#F4FBFE"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.362 47.4789L298.045 47.4049C298.04 47.4024 298.035 47.4023 298.035 47.4023H298.045L298.362 47.4789Z",
    fill: "url(#paint145_linear_9008_207327)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.069 66.5961L314.304 64.9973C312.043 59.8791 308.212 55.1992 303.9 52.7946C302.388 51.4821 300.791 50.3546 299.127 49.4576C296.382 47.9804 294.071 47.3799 292.182 47.2405L292.361 47.2254C293.03 47.1088 293.706 47.048 294.385 47.0328L294.539 47.0176L295.045 47.0277C295.529 47.0404 296.015 47.0809 296.504 47.1417L296.914 47.1924C297.01 47.2076 297.104 47.2228 297.2 47.238C297.436 47.2811 297.646 47.3216 297.856 47.3672C297.866 47.3698 297.876 47.3723 297.889 47.3748L298.036 47.4027C298.036 47.4027 298.041 47.4027 298.046 47.4052L298.362 47.4787L298.866 47.6155C299.107 47.6839 299.345 47.7549 299.585 47.8334L300.241 48.0463L300.573 48.1932C300.677 48.2338 300.781 48.2769 300.884 48.3174C301.614 48.6113 302.348 48.9407 303.095 49.341C303.523 49.5716 303.958 49.8301 304.399 50.1139L304.401 50.1164C304.434 50.1366 304.467 50.1569 304.5 50.1797C304.505 50.1823 304.508 50.1848 304.513 50.1873C304.525 50.1949 304.538 50.2051 304.553 50.2127C304.558 50.2178 304.563 50.2203 304.568 50.2228C304.579 50.2304 304.591 50.238 304.601 50.2456L304.647 50.276C304.662 50.2862 304.675 50.2938 304.69 50.3039C304.695 50.3064 304.7 50.3115 304.705 50.314C304.715 50.3216 304.725 50.3267 304.736 50.3343L304.741 50.3368C306.999 51.852 309.377 54.0412 311.534 56.7651L311.539 56.7726C311.549 56.7828 311.557 56.7954 311.567 56.8056C311.572 56.8132 311.577 56.8208 311.585 56.8284C311.59 56.836 311.592 56.8411 311.597 56.8461C311.605 56.8563 311.615 56.8664 311.623 56.8765L311.63 56.8866C311.638 56.8993 311.648 56.9095 311.658 56.9221L311.661 56.9272C311.671 56.9399 311.681 56.95 311.689 56.9627L311.691 56.9678C312.762 58.3385 313.778 59.8461 314.692 61.4652C315.593 63.0691 316.401 64.7845 317.069 66.5961Z",
    fill: "url(#paint146_linear_9008_207327)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M303.9 52.7943C303.118 52.3585 302.353 52.0164 301.614 51.7631C300.54 50.9345 299.434 50.1997 298.304 49.5739C295.749 48.16 293.331 47.448 291.156 47.3669C291.374 47.3213 291.592 47.2808 291.812 47.2427C291.817 47.2453 291.825 47.2453 291.832 47.2453L292.174 47.2427L292.182 47.2402C294.071 47.3796 296.382 47.9801 299.127 49.4573C300.791 50.3543 302.391 51.4818 303.9 52.7943Z",
    fill: "#ECF8FE"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.613 51.7633C300.54 51.3959 299.517 51.2185 298.562 51.2185C297.972 51.2185 297.408 51.2869 296.873 51.4212C296.58 51.2413 296.284 51.069 295.987 50.9043C293.273 49.4018 290.713 48.6898 288.432 48.6898C287.945 48.6898 287.472 48.7228 287.014 48.7861C288.386 48.1299 289.769 47.6586 291.156 47.3672C293.331 47.4483 295.749 48.1603 298.304 49.5741C299.433 50.2 300.54 50.9348 301.613 51.7633Z",
    fill: "url(#paint147_linear_9008_207327)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 52.3198C292.763 51.1492 290.73 50.4904 288.861 50.3003L286.598 48.9929C286.737 48.922 286.874 48.8561 287.013 48.7877C287.471 48.7243 287.945 48.6914 288.431 48.6914C290.712 48.6914 293.272 49.4034 295.987 50.9059C296.283 51.0706 296.579 51.2429 296.873 51.4228C296.154 51.6052 295.493 51.9042 294.9 52.3198Z",
    fill: "#D9EEF9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.89 53.2051L288.861 50.2988C290.73 50.4889 292.763 51.1476 294.9 52.3182C294.536 52.5716 294.199 52.8681 293.89 53.2051Z",
    fill: "url(#paint148_linear_9008_207327)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.303 64.9976L312.564 63.9942C310.328 59.7299 307.345 55.7899 303.896 52.7949C308.209 55.1995 312.042 59.8794 314.303 64.9976Z",
    fill: "url(#paint149_linear_9008_207327)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M312.564 63.9942L311.336 63.2822C308.769 58.7518 305.391 54.6775 301.613 51.7637C302.353 52.0171 303.117 52.3591 303.9 52.7949C307.346 55.7899 310.329 59.7299 312.564 63.9942Z",
    fill: "#F0F9FE"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.336 63.2821L306.264 60.3531C303.568 56.6791 300.342 53.5397 296.873 51.4215C297.407 51.2872 297.972 51.2188 298.562 51.2188C299.517 51.2188 300.539 51.3961 301.613 51.7635C305.391 54.6774 308.769 58.7517 311.336 63.2821Z",
    fill: "url(#paint150_linear_9008_207327)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M306.264 60.3535L301.793 57.7716C299.699 55.5596 297.392 53.6998 294.979 52.3619C294.954 52.3467 294.926 52.334 294.9 52.3188C295.493 51.9033 296.154 51.6043 296.873 51.4219C300.342 53.5401 303.568 56.6795 306.264 60.3535Z",
    fill: "#E1F3FC"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.793 57.7711L293.891 53.2052C294.2 52.8682 294.536 52.5717 294.901 52.3184C294.926 52.3336 294.954 52.3462 294.979 52.3614C297.392 53.6993 299.699 55.5591 301.793 57.7711Z",
    fill: "url(#paint151_linear_9008_207327)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 92.5,
    r: 8.5,
    fill: "white",
    stroke: "#00C108",
    strokeWidth: 2
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M258.626 87.3514V97.5332H255.862V89.8968H255.802L253.575 91.2292V88.8826L256.08 87.3514H258.626Z",
    fill: "#00C108"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 127.5,
    r: 8.5,
    fill: "white",
    stroke: "#00C108",
    strokeWidth: 2
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M252.65 132.533V130.545L256.448 127.403C256.7 127.194 256.916 126.998 257.095 126.816C257.277 126.63 257.416 126.44 257.512 126.244C257.612 126.049 257.661 125.831 257.661 125.593C257.661 125.331 257.605 125.107 257.492 124.922C257.383 124.736 257.231 124.594 257.035 124.494C256.839 124.391 256.614 124.34 256.359 124.34C256.104 124.34 255.878 124.391 255.683 124.494C255.491 124.597 255.341 124.748 255.235 124.947C255.129 125.145 255.076 125.387 255.076 125.672H252.451C252.451 124.956 252.612 124.34 252.933 123.823C253.255 123.306 253.709 122.908 254.296 122.63C254.882 122.351 255.57 122.212 256.359 122.212C257.174 122.212 257.88 122.343 258.477 122.605C259.077 122.863 259.539 123.228 259.864 123.699C260.192 124.169 260.356 124.721 260.356 125.354C260.356 125.745 260.275 126.135 260.112 126.523C259.95 126.907 259.658 127.333 259.237 127.8C258.817 128.268 258.218 128.824 257.443 129.471L256.488 130.266V130.326H260.465V132.533H252.65Z",
    fill: "#00C108"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 161.5,
    r: 8.5,
    fill: "white",
    stroke: "#00C108",
    strokeWidth: 2
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M256.429 166.672C255.627 166.672 254.914 166.535 254.291 166.26C253.672 165.981 253.184 165.599 252.83 165.111C252.475 164.624 252.296 164.064 252.293 163.431H255.077C255.08 163.626 255.14 163.802 255.256 163.958C255.375 164.11 255.538 164.23 255.743 164.316C255.949 164.402 256.184 164.445 256.449 164.445C256.704 164.445 256.93 164.4 257.125 164.311C257.321 164.218 257.473 164.09 257.583 163.928C257.692 163.766 257.745 163.58 257.742 163.371C257.745 163.166 257.682 162.983 257.553 162.824C257.427 162.665 257.249 162.541 257.021 162.452C256.792 162.362 256.529 162.317 256.23 162.317H255.196V160.408H256.23C256.505 160.408 256.747 160.363 256.956 160.274C257.168 160.184 257.332 160.06 257.448 159.901C257.568 159.742 257.626 159.56 257.622 159.354C257.626 159.155 257.578 158.98 257.478 158.827C257.379 158.675 257.239 158.555 257.061 158.469C256.885 158.383 256.681 158.34 256.449 158.34C256.197 158.34 255.972 158.385 255.773 158.474C255.577 158.564 255.423 158.688 255.311 158.847C255.198 159.006 255.14 159.189 255.137 159.394H252.492C252.495 158.771 252.666 158.221 253.004 157.743C253.345 157.266 253.812 156.892 254.406 156.62C254.999 156.348 255.68 156.212 256.449 156.212C257.201 156.212 257.866 156.34 258.443 156.595C259.023 156.85 259.475 157.202 259.8 157.649C260.128 158.093 260.29 158.602 260.287 159.175C260.294 159.745 260.098 160.213 259.7 160.577C259.306 160.942 258.806 161.157 258.199 161.224V161.303C259.021 161.393 259.639 161.644 260.053 162.059C260.468 162.47 260.672 162.987 260.665 163.61C260.668 164.206 260.489 164.735 260.128 165.196C259.77 165.657 259.271 166.018 258.632 166.28C257.995 166.541 257.261 166.672 256.429 166.672Z",
    fill: "#00C108"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M276.145 81.5868L279.77 79.8633V184.942L276.145 188.389V81.5868Z",
    fill: "#8C8C8C"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M272 79L276.144 81.5839V188.386L272 185.802V79Z",
    fill: "#D9D9D9"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 168.999L70.1953 61.7773L241.5 62.499L276.5 82.4994V183.499L241.5 168.999Z",
    fill: "url(#paint152_linear_9008_207327)",
    fillOpacity: 0.6
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0942 65.3432L46.2326 61.2232C46.8363 60.876 47.3268 61.1552 47.3268 61.857V70.0972C47.3268 70.7914 46.8363 71.6441 46.2326 71.9912L39.0942 76.1113C38.4905 76.4584 38 76.1792 38 75.4774V67.2373C38.0075 66.543 38.4905 65.6903 39.0942 65.3432Z",
    fill: "#374A57"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5234 61.6311L46.9949 61.1406L47.9759 61.7066L46.0064 62.4159L45.5234 61.6311Z",
    fill: "#374A57"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2871 76.1568L40 75.5078L40.9885 76.0738L39.3058 76.7378L38.2871 76.1568Z",
    fill: "#374A57"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0238 76.6412L47.1623 72.5211C47.766 72.174 48.2564 71.3288 48.2564 70.6271V62.3869C48.2564 61.6927 47.766 61.4059 47.1623 61.7531L40.0238 65.8731C39.4202 66.2202 38.9297 67.0654 38.9297 67.7672V76.0073C38.9297 76.7015 39.4202 76.9883 40.0238 76.6412Z",
    fill: "#8A9CA8"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 63.4269C46.6641 63.6684 46.8301 63.7665 47.0414 63.6457C47.2526 63.525 47.4187 63.2307 47.4187 62.9893C47.4187 62.7478 47.2526 62.6497 47.0414 62.7704C46.8301 62.8912 46.6641 63.1854 46.6641 63.4269Z",
    fill: "#374A57"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 67.4152C39.7578 67.6567 39.9238 67.7548 40.1351 67.634C40.3464 67.5133 40.5124 67.219 40.5124 66.9775C40.5124 66.7361 40.3464 66.638 40.1351 66.7587C39.9314 66.8794 39.7578 67.1737 39.7578 67.4152Z",
    fill: "#374A57"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6641 71.3214C46.6641 71.5629 46.8301 71.661 47.0414 71.5403C47.2526 71.4195 47.4187 71.1253 47.4187 70.8838C47.4187 70.6423 47.2526 70.5442 47.0414 70.6649C46.8376 70.7857 46.6641 71.08 46.6641 71.3214Z",
    fill: "#3C3C3B"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 75.3058C39.7578 75.5473 39.9238 75.6454 40.1351 75.5247C40.3464 75.4039 40.5124 75.1096 40.5124 74.8682C40.5124 74.6267 40.3464 74.5286 40.1351 74.6493C39.9314 74.7701 39.7578 75.0644 39.7578 75.3058Z",
    fill: "#374A57"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9688 70.1278C41.9688 71.1616 42.6932 71.5842 43.5911 71.0635C44.4891 70.5429 45.2135 69.2902 45.2135 68.2565C45.2135 67.2227 44.4891 66.8001 43.5911 67.3208C42.6932 67.8414 41.9688 69.0941 41.9688 70.1278Z",
    fill: "#3C3C3B"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4492 70.6923C41.4492 72.3448 42.6113 73.0164 44.045 72.1939C45.4787 71.3638 46.6408 69.3491 46.6408 67.6965C46.6408 66.044 45.4787 65.3724 44.045 66.1949C42.6113 67.0249 41.4492 69.0397 41.4492 70.6923Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3847 73.273C53.9129 73.273 54.4034 72.9259 54.5618 72.3977C54.758 71.7488 54.3883 71.0696 53.7393 70.8734L44.5484 68.1418C43.8994 67.9456 43.3938 68.3229 43.1977 68.9719C43.0015 69.6208 43.1977 70.2999 43.8466 70.4886L53.0375 73.2202C53.1507 73.2579 53.2715 73.273 53.3847 73.273Z",
    fill: "#8A9CA8"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5684 72.0504C51.5684 73.5219 52.7606 74.7141 54.2321 74.7141C55.7035 74.7141 56.8958 73.5219 56.8958 72.0504C56.8958 70.579 55.7035 69.3867 54.2321 69.3867C52.7606 69.3867 51.5684 70.579 51.5684 72.0504Z",
    fill: "#374A57"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8515 71.1068C55.4023 71.1068 55.9079 70.7295 56.0437 70.1711L58.0887 61.7046C58.2471 61.0481 57.8396 60.3841 57.1832 60.2256C56.5267 60.0671 55.8626 60.4746 55.7041 61.1311L53.6592 69.5976C53.5007 70.2541 53.9082 70.9182 54.5647 71.0766C54.6628 71.0993 54.7534 71.1068 54.8515 71.1068Z",
    fill: "#8A9CA8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9062 60.2021C53.9062 62.2923 55.6041 63.9902 57.6943 63.9902C59.7845 63.9902 61.4824 62.2923 61.4824 60.2021C61.4824 58.1119 59.7845 56.4141 57.6943 56.4141C55.6041 56.4141 53.9062 58.1119 53.9062 60.2021Z",
    fill: "#374A57"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5513 56.9519L54.7285 44.3503C53.7777 43.7994 52.4723 43.8824 51.0234 44.7125L75.6609 58.9365C76.7852 59.5855 77.902 58.031 76.906 57.201C76.8984 57.1934 76.8909 57.1859 76.8833 57.1859C76.838 57.1481 76.7928 57.118 76.7475 57.0878L76.7173 57.118L76.5513 56.9519Z",
    fill: "#374A57"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8926 48.1161C55.8926 45.1354 53.8024 43.9281 51.2217 45.4222C48.641 46.9087 46.5508 50.5308 46.5508 53.5114C46.5508 56.4921 48.641 57.6994 51.2217 56.2053C53.8024 54.7112 55.8926 51.0892 55.8926 48.1161Z",
    fill: "#8A9CA8"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5265 45.0974L47.9238 56.5332L67.404 67.7804L74.0067 56.3446L54.5265 45.0974Z",
    fill: "#8A9CA8"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7061 56.665C68.1254 58.1515 66.0352 61.7736 66.0352 64.7542C66.0352 67.7348 68.1254 68.9422 70.7061 67.4481C73.2868 65.9615 75.377 62.3395 75.377 59.3589C75.377 56.3782 73.2868 55.1784 70.7061 56.665ZM73.3547 57.4648C73.8075 57.7289 74.0716 58.4156 74.0716 59.3589C74.0716 60.5587 73.6415 61.9924 72.8793 63.3054C72.1247 64.6184 71.0909 65.7125 70.0571 66.3087C69.2422 66.7765 68.5178 66.8972 68.065 66.6331C67.8613 66.5199 67.7028 66.3162 67.5821 66.0445C67.4312 65.705 67.3557 65.2673 67.3557 64.7466C67.3557 63.5544 67.7934 62.1131 68.548 60.8001C69.3025 59.4871 70.3363 58.393 71.3701 57.7893C71.8229 57.5327 72.2455 57.3743 72.6077 57.3366C72.8944 57.3139 73.151 57.3516 73.3547 57.4648Z",
    fill: "#EDEDED"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0635 59.3564C74.0635 60.5562 73.6334 61.99 72.8713 63.3029C72.1167 64.6159 71.0829 65.7101 70.0491 66.3062C69.2341 66.7741 68.5097 66.8948 68.057 66.6307C67.8532 66.5175 67.6948 66.3138 67.574 66.0421C67.4231 65.7026 67.3477 65.2649 67.3477 64.7442C67.3477 63.552 67.7853 62.1107 68.5399 60.7977C69.2945 59.4847 70.3283 58.3906 71.3621 57.7869C71.8148 57.5303 72.2374 57.3718 72.5996 57.3341C72.8939 57.3039 73.1505 57.3417 73.3542 57.4624C73.807 57.7265 74.0711 58.4207 74.0635 59.3564Z",
    fill: "#374A57"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6002 57.3438C72.238 57.3815 71.8078 57.5399 71.3626 57.7965C71.3249 57.8191 71.2947 57.8418 71.257 57.8644C71.0004 58.0229 70.7439 58.2115 70.4948 58.4228C69.7704 59.0416 69.0913 59.8641 68.548 60.8073C68.0047 61.7506 67.6274 62.7542 67.4614 63.6899C67.401 64.0143 67.3633 64.3313 67.3633 64.6331C67.3633 64.6784 67.3633 64.7161 67.3633 64.7614C67.3633 65.2821 67.4463 65.7273 67.5897 66.0593C68.0349 66.1574 68.631 66.0216 69.2724 65.6744C70.2911 65.116 71.2947 64.0747 72.0191 62.8145C72.7435 61.5544 73.151 60.1659 73.1208 59.0039C73.0906 58.2568 72.902 57.6758 72.6002 57.3438Z",
    fill: "#8A9CA8"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2492 57.8574C70.9926 58.0159 70.736 58.2045 70.487 58.4158C69.7626 59.0346 69.0835 59.8571 68.5402 60.8003C67.9969 61.7436 67.6196 62.7472 67.4536 63.6829C67.3932 64.0073 67.3555 64.3243 67.3555 64.6261C67.846 64.8525 68.4949 64.7921 69.2042 64.3771C70.7285 63.4942 71.9736 61.3512 71.9736 59.5854C71.966 58.7629 71.6944 58.1668 71.2492 57.8574Z",
    fill: "#3C3C3B"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4866 58.416C69.7622 59.0348 69.083 59.8573 68.5397 60.8005C67.9964 61.7438 67.6191 62.7474 67.4531 63.6831C67.8455 63.9321 68.3964 63.9094 69.0151 63.5548C70.2074 62.8681 71.1657 61.2005 71.1657 59.8271C71.1582 59.1253 70.9016 58.6348 70.4866 58.416Z",
    fill: "#1D1D1B"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.4496 62.3092C68.8042 62.1054 69.1589 61.7281 69.4381 61.2754L70.087 61.781C69.7475 62.3167 69.3098 62.7619 68.857 63.0185C68.5099 63.2147 68.1854 63.2977 67.9062 63.2524L68.0496 62.445C68.1175 62.4526 68.2458 62.4299 68.4496 62.3092Z",
    fill: "#EDEDED"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3849 52.3616C48.1887 52.2484 48.0906 51.9541 48.1661 51.7051C48.2415 51.4561 48.4604 51.3429 48.6566 51.4561L65.3934 61.1224C65.5896 61.2356 65.6877 61.5299 65.6122 61.7789C65.5368 62.0279 65.3179 62.1411 65.1218 62.0279L48.3849 52.3616Z",
    fill: "#C6C6C6"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9623 54.3783C47.7661 54.2651 47.6227 54.001 47.6378 53.7821C47.6529 53.5633 47.8265 53.4803 48.0226 53.5935L64.7595 63.2598C64.9557 63.373 65.0991 63.6371 65.084 63.856C65.0689 64.0748 64.8953 64.1578 64.6991 64.0446L47.9623 54.3783Z",
    fill: "#C6C6C6"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0167 45.0958L74.2615 56.206C73.7207 56.3283 73.1605 56.5545 72.5975 56.8817C71.0569 57.7726 69.6872 59.2701 68.7108 60.9723C68.5223 61.2945 68.3501 61.6234 68.194 61.9512L68.1927 61.954C67.363 63.7245 65.1568 64.3913 63.4398 63.4008C63.4397 63.4008 63.4397 63.4008 63.4396 63.4007L47.0287 53.9239C47.0285 53.9238 47.0283 53.9237 47.0281 53.9236C46.5561 53.6489 46.3011 53.1121 46.3879 52.5804L46.3881 52.5797C46.5883 51.3423 47.0703 50.0563 47.7536 48.8713C48.6718 47.2827 49.9201 45.9295 51.2751 45.1458C52.6343 44.3674 53.7395 44.3538 54.4801 44.7829L54.4801 44.783L54.4879 44.7873C54.5326 44.8121 54.5814 44.8444 54.6269 44.8785L54.9738 45.1387L55.0167 45.0958Z",
    fill: "white",
    stroke: "#D9D9D9"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7637 57.0737L76.5527 56.9531C76.6205 56.9908 76.6884 57.036 76.7562 57.0888L76.7637 57.0737Z",
    fill: "#C6C6C6"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6513 62.349C63.4023 62.2056 63.1155 62.3113 63.0174 62.5905C62.9193 62.8697 63.0476 63.2168 63.2966 63.3602C63.5456 63.5035 63.8324 63.3979 63.9305 63.1187C64.0286 62.8395 63.9003 62.4999 63.6513 62.349Z",
    fill: "#374A57"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3622 59.3021C58.1132 59.1587 57.8265 59.2644 57.7284 59.5436C57.6303 59.8228 57.7585 60.1699 58.0076 60.3133C58.2566 60.4566 58.5433 60.351 58.6414 60.0718C58.7395 59.7926 58.6112 59.4455 58.3622 59.3021Z",
    fill: "#374A57"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0692 56.2435C52.8202 56.1002 52.5335 56.2058 52.4354 56.485C52.3373 56.7642 52.4656 57.1113 52.7146 57.2547C52.9636 57.3981 53.2504 57.2924 53.3484 57.0132C53.4465 56.734 53.3258 56.3944 53.0692 56.2435Z",
    fill: "#374A57"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7802 53.1927C47.5312 53.0494 47.2444 53.155 47.1463 53.4342C47.0482 53.7134 47.1765 54.0605 47.4255 54.2039C47.6745 54.3473 47.9613 54.2416 48.0594 53.9624C48.165 53.6832 48.0367 53.3361 47.7802 53.1927Z",
    fill: "#374A57"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1953 62.1582L240 62.5",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3145 62.1699L240.5 169",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3184 62.166L278 186",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3164 62.1641L275 83.5",
    stroke: "#69D2FF",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9008_207327",
    x1: 283.951,
    y1: 116.069,
    x2: 309.072,
    y2: 72.5898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9008_207327",
    x1: 260.683,
    y1: 129.422,
    x2: 285.804,
    y2: 85.9432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9008_207327",
    x1: 250.483,
    y1: 136.529,
    x2: 274.544,
    y2: 94.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9008_207327",
    x1: 250.555,
    y1: 169.159,
    x2: 264.448,
    y2: 151.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9008_207327",
    x1: 298.358,
    y1: 115.835,
    x2: 338.67,
    y2: 46.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9008_207327",
    x1: 272.564,
    y1: 123.776,
    x2: 296.661,
    y2: 82.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9008_207327",
    x1: 260.684,
    y1: 129.422,
    x2: 285.804,
    y2: 85.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9008_207327",
    x1: 250.484,
    y1: 136.528,
    x2: 274.544,
    y2: 94.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9008_207327",
    x1: 250.555,
    y1: 169.16,
    x2: 264.449,
    y2: 151.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9008_207327",
    x1: 298.358,
    y1: 115.835,
    x2: 338.671,
    y2: 46.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9008_207327",
    x1: 272.564,
    y1: 123.776,
    x2: 296.662,
    y2: 82.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9008_207327",
    x1: 298.358,
    y1: 115.835,
    x2: 338.671,
    y2: 46.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9008_207327",
    x1: 291.17,
    y1: 111.923,
    x2: 316.291,
    y2: 68.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9008_207327",
    x1: 287.829,
    y1: 115.045,
    x2: 311.901,
    y2: 73.3799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9008_207327",
    x1: 283.951,
    y1: 116.067,
    x2: 309.072,
    y2: 72.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9008_207327",
    x1: 272.565,
    y1: 123.776,
    x2: 296.663,
    y2: 82.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9008_207327",
    x1: 229.244,
    y1: 158.136,
    x2: 243.68,
    y2: 183.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4073B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345DAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9008_207327",
    x1: 291.169,
    y1: 111.922,
    x2: 316.289,
    y2: 68.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9008_207327",
    x1: 287.829,
    y1: 115.044,
    x2: 311.902,
    y2: 73.3782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9008_207327",
    x1: 283.95,
    y1: 116.067,
    x2: 309.071,
    y2: 72.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9008_207327",
    x1: 272.564,
    y1: 123.777,
    x2: 296.662,
    y2: 82.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9008_207327",
    x1: 260.684,
    y1: 129.422,
    x2: 285.805,
    y2: 85.9428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9008_207327",
    x1: 250.483,
    y1: 136.528,
    x2: 274.543,
    y2: 94.8837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9008_207327",
    x1: 250.556,
    y1: 169.16,
    x2: 264.449,
    y2: 151.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB2DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9008_207327",
    x1: 248.362,
    y1: 159.135,
    x2: 253.841,
    y2: 168.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9008_207327",
    x1: 298.358,
    y1: 115.835,
    x2: 338.671,
    y2: 46.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9008_207327",
    x1: 291.17,
    y1: 111.923,
    x2: 316.291,
    y2: 68.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9008_207327",
    x1: 287.829,
    y1: 115.045,
    x2: 311.901,
    y2: 73.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9008_207327",
    x1: 283.951,
    y1: 116.069,
    x2: 309.072,
    y2: 72.5898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9008_207327",
    x1: 272.564,
    y1: 123.777,
    x2: 296.661,
    y2: 82.0675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9008_207327",
    x1: 298.357,
    y1: 115.836,
    x2: 338.67,
    y2: 46.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9008_207327",
    x1: 291.169,
    y1: 111.922,
    x2: 316.289,
    y2: 68.4427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9008_207327",
    x1: 287.829,
    y1: 115.044,
    x2: 311.901,
    y2: 73.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_9008_207327",
    x1: 283.952,
    y1: 116.07,
    x2: 309.072,
    y2: 72.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_9008_207327",
    x1: 272.564,
    y1: 123.776,
    x2: 296.662,
    y2: 82.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_9008_207327",
    x1: 244.54,
    y1: 161.15,
    x2: 250.188,
    y2: 151.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_9008_207327",
    x1: 298.358,
    y1: 115.835,
    x2: 338.671,
    y2: 46.0615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_9008_207327",
    x1: 298.358,
    y1: 115.834,
    x2: 338.67,
    y2: 46.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_9008_207327",
    x1: 291.169,
    y1: 111.922,
    x2: 316.289,
    y2: 68.4435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9008_207327",
    x1: 298.358,
    y1: 82.8638,
    x2: 338.67,
    y2: 13.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_9008_207327",
    x1: 291.17,
    y1: 78.9499,
    x2: 316.29,
    y2: 35.4707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9008_207327",
    x1: 283.951,
    y1: 83.093,
    x2: 309.072,
    y2: 39.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9008_207327",
    x1: 272.564,
    y1: 90.8016,
    x2: 296.662,
    y2: 49.0926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9008_207327",
    x1: 260.684,
    y1: 96.4488,
    x2: 285.804,
    y2: 52.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9008_207327",
    x1: 250.483,
    y1: 103.557,
    x2: 274.543,
    y2: 61.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9008_207327",
    x1: 298.359,
    y1: 82.8639,
    x2: 338.672,
    y2: 13.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9008_207327",
    x1: 272.564,
    y1: 90.8027,
    x2: 296.662,
    y2: 49.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9008_207327",
    x1: 260.684,
    y1: 96.449,
    x2: 285.804,
    y2: 52.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9008_207327",
    x1: 250.483,
    y1: 103.557,
    x2: 274.544,
    y2: 61.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9008_207327",
    x1: 250.556,
    y1: 136.187,
    x2: 264.449,
    y2: 118.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9008_207327",
    x1: 298.359,
    y1: 82.8631,
    x2: 338.672,
    y2: 13.0892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9008_207327",
    x1: 272.564,
    y1: 90.8,
    x2: 296.662,
    y2: 49.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_9008_207327",
    x1: 298.358,
    y1: 82.8634,
    x2: 338.671,
    y2: 13.0896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_9008_207327",
    x1: 291.17,
    y1: 78.9507,
    x2: 316.29,
    y2: 35.4716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9008_207327",
    x1: 287.829,
    y1: 82.0728,
    x2: 311.902,
    y2: 40.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_9008_207327",
    x1: 283.952,
    y1: 83.0949,
    x2: 309.072,
    y2: 39.6159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9008_207327",
    x1: 272.563,
    y1: 90.8027,
    x2: 296.661,
    y2: 49.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9008_207327",
    x1: 250.485,
    y1: 136.529,
    x2: 274.546,
    y2: 94.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9008_207327",
    x1: 260.684,
    y1: 129.315,
    x2: 286.076,
    y2: 85.6808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B2DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9008_207327",
    x1: 250.484,
    y1: 136.527,
    x2: 274.545,
    y2: 94.8832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B2DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_9008_207327",
    x1: 283.951,
    y1: 116.069,
    x2: 309.072,
    y2: 72.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84BFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_9008_207327",
    x1: 250.485,
    y1: 136.528,
    x2: 274.545,
    y2: 94.8835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A92CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_9008_207327",
    x1: 291.17,
    y1: 111.809,
    x2: 316.578,
    y2: 68.1673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_9008_207327",
    x1: 291.169,
    y1: 78.9525,
    x2: 316.289,
    y2: 35.4734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_9008_207327",
    x1: 287.829,
    y1: 82.0733,
    x2: 311.901,
    y2: 40.4086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_9008_207327",
    x1: 283.95,
    y1: 83.0948,
    x2: 309.071,
    y2: 39.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_9008_207327",
    x1: 272.564,
    y1: 90.8001,
    x2: 296.662,
    y2: 49.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_9008_207327",
    x1: 260.684,
    y1: 96.4492,
    x2: 285.805,
    y2: 52.9702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_9008_207327",
    x1: 250.483,
    y1: 103.557,
    x2: 274.543,
    y2: 61.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_9008_207327",
    x1: 250.556,
    y1: 136.187,
    x2: 264.449,
    y2: 118.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB2DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_9008_207327",
    x1: 248.362,
    y1: 126.163,
    x2: 253.841,
    y2: 135.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_9008_207327",
    x1: 298.358,
    y1: 82.8641,
    x2: 338.671,
    y2: 13.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_9008_207327",
    x1: 291.17,
    y1: 78.951,
    x2: 316.291,
    y2: 35.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_9008_207327",
    x1: 287.829,
    y1: 82.0711,
    x2: 311.901,
    y2: 40.4059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_9008_207327",
    x1: 283.951,
    y1: 83.094,
    x2: 309.072,
    y2: 39.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_9008_207327",
    x1: 272.564,
    y1: 90.8014,
    x2: 296.662,
    y2: 49.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_9008_207327",
    x1: 298.357,
    y1: 82.8636,
    x2: 338.67,
    y2: 13.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_9008_207327",
    x1: 291.169,
    y1: 78.9517,
    x2: 316.289,
    y2: 35.4726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_9008_207327",
    x1: 287.829,
    y1: 82.0733,
    x2: 311.901,
    y2: 40.4081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_9008_207327",
    x1: 283.951,
    y1: 83.093,
    x2: 309.072,
    y2: 39.6139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_9008_207327",
    x1: 272.564,
    y1: 90.8015,
    x2: 296.662,
    y2: 49.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_9008_207327",
    x1: 250.556,
    y1: 136.187,
    x2: 264.449,
    y2: 118.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68A3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72AEDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_9008_207327",
    x1: 244.54,
    y1: 128.177,
    x2: 250.188,
    y2: 118.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_9008_207327",
    x1: 298.359,
    y1: 82.8631,
    x2: 338.672,
    y2: 13.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_9008_207327",
    x1: 298.358,
    y1: 82.863,
    x2: 338.67,
    y2: 13.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_9008_207327",
    x1: 291.17,
    y1: 78.9503,
    x2: 316.291,
    y2: 35.4711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_9008_207327",
    x1: 298.358,
    y1: 49.5287,
    x2: 338.671,
    y2: -20.2454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_9008_207327",
    x1: 291.17,
    y1: 45.6164,
    x2: 316.291,
    y2: 2.13731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_9008_207327",
    x1: 283.952,
    y1: 49.759,
    x2: 309.072,
    y2: 6.27989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_9008_207327",
    x1: 272.564,
    y1: 57.4684,
    x2: 296.662,
    y2: 15.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_9008_207327",
    x1: 260.684,
    y1: 63.1145,
    x2: 285.805,
    y2: 19.6355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_9008_207327",
    x1: 250.483,
    y1: 70.2219,
    x2: 274.543,
    y2: 28.5776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_9008_207327",
    x1: 298.358,
    y1: 49.5297,
    x2: 338.671,
    y2: -20.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_9008_207327",
    x1: 298.357,
    y1: 49.5285,
    x2: 338.669,
    y2: -20.2453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_9008_207327",
    x1: 291.169,
    y1: 45.6164,
    x2: 316.29,
    y2: 2.13723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_9008_207327",
    x1: 287.829,
    y1: 48.7385,
    x2: 311.901,
    y2: 7.07355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_9008_207327",
    x1: 283.952,
    y1: 49.7581,
    x2: 309.073,
    y2: 6.27891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_9008_207327",
    x1: 272.564,
    y1: 57.469,
    x2: 296.662,
    y2: 15.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_9008_207327",
    x1: 260.682,
    y1: 63.1161,
    x2: 285.803,
    y2: 19.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_9008_207327",
    x1: 250.483,
    y1: 70.2214,
    x2: 274.544,
    y2: 28.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_9008_207327",
    x1: 250.556,
    y1: 102.851,
    x2: 264.449,
    y2: 85.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_9008_207327",
    x1: 298.357,
    y1: 49.5298,
    x2: 338.671,
    y2: -20.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_9008_207327",
    x1: 298.358,
    y1: 49.5293,
    x2: 338.668,
    y2: -20.2427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_9008_207327",
    x1: 298.357,
    y1: 49.5286,
    x2: 338.669,
    y2: -20.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_9008_207327",
    x1: 287.829,
    y1: 48.7377,
    x2: 311.901,
    y2: 7.07281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_9008_207327",
    x1: 283.95,
    y1: 49.7581,
    x2: 309.071,
    y2: 6.27914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_9008_207327",
    x1: 272.564,
    y1: 57.4694,
    x2: 296.662,
    y2: 15.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_9008_207327",
    x1: 298.358,
    y1: 49.5287,
    x2: 338.671,
    y2: -20.2454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_9008_207327",
    x1: 291.169,
    y1: 45.6151,
    x2: 316.289,
    y2: 2.13608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_9008_207327",
    x1: 287.829,
    y1: 48.738,
    x2: 311.902,
    y2: 7.07304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_9008_207327",
    x1: 283.952,
    y1: 49.7597,
    x2: 309.072,
    y2: 6.28059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_9008_207327",
    x1: 272.564,
    y1: 57.4683,
    x2: 296.662,
    y2: 15.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6ECFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_9008_207327",
    x1: 260.686,
    y1: 96.3357,
    x2: 286.101,
    y2: 52.6894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B2DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_9008_207327",
    x1: 250.485,
    y1: 103.556,
    x2: 274.546,
    y2: 61.9113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_9008_207327",
    x1: 250.484,
    y1: 103.555,
    x2: 274.545,
    y2: 61.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B2DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_9008_207327",
    x1: 283.95,
    y1: 82.9811,
    x2: 309.362,
    y2: 39.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84BFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_9008_207327",
    x1: 250.485,
    y1: 103.556,
    x2: 274.546,
    y2: 61.9113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A92CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_9008_207327",
    x1: 291.17,
    y1: 78.8439,
    x2: 316.569,
    y2: 35.2067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_9008_207327",
    x1: 298.357,
    y1: 49.5291,
    x2: 338.67,
    y2: -20.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_9008_207327",
    x1: 291.169,
    y1: 45.6166,
    x2: 316.289,
    y2: 2.13746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_9008_207327",
    x1: 287.829,
    y1: 48.7402,
    x2: 311.9,
    y2: 7.07643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_9008_207327",
    x1: 283.95,
    y1: 49.7601,
    x2: 309.071,
    y2: 6.28094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_9008_207327",
    x1: 272.564,
    y1: 57.4701,
    x2: 296.662,
    y2: 15.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_9008_207327",
    x1: 260.684,
    y1: 63.1152,
    x2: 285.805,
    y2: 19.6361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_9008_207327",
    x1: 250.483,
    y1: 70.223,
    x2: 274.543,
    y2: 28.5787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_9008_207327",
    x1: 250.556,
    y1: 102.851,
    x2: 264.449,
    y2: 85.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB2DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_9008_207327",
    x1: 248.362,
    y1: 92.8287,
    x2: 253.841,
    y2: 102.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_9008_207327",
    x1: 298.358,
    y1: 49.5287,
    x2: 338.671,
    y2: -20.2453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_9008_207327",
    x1: 291.17,
    y1: 45.617,
    x2: 316.291,
    y2: 2.13792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_9008_207327",
    x1: 287.829,
    y1: 48.7392,
    x2: 311.901,
    y2: 7.07431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_9008_207327",
    x1: 283.951,
    y1: 49.7595,
    x2: 309.072,
    y2: 6.28041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_9008_207327",
    x1: 272.564,
    y1: 57.4699,
    x2: 296.662,
    y2: 15.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87BEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_9008_207327",
    x1: 298.357,
    y1: 49.5291,
    x2: 338.67,
    y2: -20.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_9008_207327",
    x1: 291.169,
    y1: 45.6172,
    x2: 316.289,
    y2: 2.13803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_9008_207327",
    x1: 287.829,
    y1: 48.7388,
    x2: 311.901,
    y2: 7.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_9008_207327",
    x1: 283.951,
    y1: 49.7584,
    x2: 309.072,
    y2: 6.27937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_9008_207327",
    x1: 272.564,
    y1: 57.4695,
    x2: 296.662,
    y2: 15.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94C9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_9008_207327",
    x1: 250.556,
    y1: 102.852,
    x2: 264.449,
    y2: 85.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68A3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72AEDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_9008_207327",
    x1: 244.54,
    y1: 94.8435,
    x2: 250.188,
    y2: 85.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_9008_207327",
    x1: 298.358,
    y1: 49.5287,
    x2: 338.671,
    y2: -20.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_9008_207327",
    x1: 291.17,
    y1: 45.6158,
    x2: 316.291,
    y2: 2.13683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_9008_207327",
    x1: 298.358,
    y1: 49.5282,
    x2: 338.671,
    y2: -20.2459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_9008_207327",
    x1: 298.358,
    y1: 49.529,
    x2: 338.671,
    y2: -20.2452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_9008_207327",
    x1: 291.17,
    y1: 45.6175,
    x2: 316.29,
    y2: 2.13887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_9008_207327",
    x1: 298.358,
    y1: 49.5277,
    x2: 338.671,
    y2: -20.2465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_9008_207327",
    x1: 298.358,
    y1: 49.5441,
    x2: 339.123,
    y2: -20.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_9008_207327",
    x1: 298.358,
    y1: 49.5286,
    x2: 338.671,
    y2: -20.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_9008_207327",
    x1: 291.17,
    y1: 45.6163,
    x2: 316.29,
    y2: 2.13727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_9008_207327",
    x1: 287.828,
    y1: 48.738,
    x2: 311.901,
    y2: 7.07294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_9008_207327",
    x1: 298.357,
    y1: 49.5289,
    x2: 338.67,
    y2: -20.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_9008_207327",
    x1: 291.169,
    y1: 45.6165,
    x2: 316.29,
    y2: 2.13748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_9008_207327",
    x1: 287.829,
    y1: 48.7381,
    x2: 311.901,
    y2: 7.07301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_9008_207327",
    x1: 16.9035,
    y1: -44.9296,
    x2: 158.791,
    y2: 150.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96C6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96C6F2",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvRedLine);
export default __webpack_public_path__ + "static/media/invRedLine.c259804e528db1ba6bbd9920c1bd1272.svg";
export { ForwardRef as ReactComponent };